
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fTmNK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $jSnXV = parcelRequire("jSnXV");


var $5d9b4 = parcelRequire("5d9b4");


var $1DWH0 = parcelRequire("1DWH0");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $6F6hl = parcelRequire("6F6hl");


var $lAFHW = parcelRequire("lAFHW");


var $jOIil = parcelRequire("jOIil");


var $fYQcF = parcelRequire("fYQcF");


var $dOOm2 = parcelRequire("dOOm2");


var $4tOXV = parcelRequire("4tOXV");


var $1k6sE = parcelRequire("1k6sE");


var $aK0Eq = parcelRequire("aK0Eq");


var $7aRa9 = parcelRequire("7aRa9");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7mpOv = parcelRequire("7mpOv");


var $kycWk = parcelRequire("kycWk");

var $iuuqT = parcelRequire("iuuqT");

var $2MwVI = parcelRequire("2MwVI");


var $1ggpj = parcelRequire("1ggpj");


var $9wGTI = parcelRequire("9wGTI");


var $8m9SI = parcelRequire("8m9SI");


var $i0AJ7 = parcelRequire("i0AJ7");


var $idaAv = parcelRequire("idaAv");





var $8C5kA = parcelRequire("8C5kA");



















const $a812429a3650bd08$export$75c1a2471a9bbe6b = ({ contentId: contentId, title: title, isEditorEmpty: isEditorEmpty, userOffline: userOffline })=>{
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [isTitleGenerating, setIsTitleGenerating] = (0, $42omo.useState)(false);
    const [shouldShowStreaming, setShouldShowStreaming] = (0, $42omo.useState)(false);
    const timeoutRef = (0, $42omo.useRef)(null);
    const proseMirrorElementRef = (0, $42omo.useRef)(null);
    const titleRef = (0, $42omo.useRef)(title);
    const wasEditorEmptyRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        wasEditorEmptyRef.current = isEditorEmpty;
    }, [
        isEditorEmpty
    ]);
    (0, $42omo.useEffect)(()=>{
        titleRef.current = title;
    }, [
        title
    ]);
    const isFeatureEnabled = isAIEnabledForContent && !userOffline && (0, $6mKj3.expValEquals)('confluence_ai_title_generation_on_paste_standard', 'isEnabled', true);
    const [documentContext, setDocumentContext] = (0, $42omo.useState)('');
    const findProseMirrorElement = (0, $42omo.useCallback)(()=>{
        const filteredProseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]'));
        return filteredProseMirrors[0];
    }, []);
    const generateTitleFromPaste = (0, $42omo.useCallback)((proseMirrorElement)=>{
        const currentTitle = titleRef.current;
        if (!isFeatureEnabled || currentTitle && currentTitle.trim() !== '') return;
        if (!proseMirrorElement) return;
        const extractedContext = proseMirrorElement.textContent || '';
        if (extractedContext.trim().length === 0) return;
        setIsTitleGenerating(true);
        experienceTracker?.start({
            name: (0, $irVI7.AI_TITLE_GENERATION)
        });
        trackAIInteractionInit({
            attributes: {
                aiFeatureName: 'aiTitleGenOnPaste'
            }
        });
        setDocumentContext(extractedContext);
        setShouldShowStreaming(true);
    }, [
        isFeatureEnabled,
        experienceTracker,
        trackAIInteractionInit
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only check if feature is enabled, not if title is empty
        // This keeps the listener active even after a title is generated
        if (!isFeatureEnabled) return;
        const proseMirrorElement = findProseMirrorElement();
        if (!proseMirrorElement) return;
        const handlePaste = (event)=>{
            const pastedText = event.clipboardData?.getData('text/plain') || '';
            const wasEditorEmpty = wasEditorEmptyRef.current;
            if (wasEditorEmpty && pastedText.length > (0, $6mKj3.expVal)('confluence_ai_title_generation_on_paste_standard', 'charLength', 50)) {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(()=>{
                    generateTitleFromPaste(proseMirrorElement);
                    timeoutRef.current = null;
                }, 100);
            }
        };
        proseMirrorElementRef.current = proseMirrorElement;
        proseMirrorElement.addEventListener('paste', handlePaste);
        return ()=>{
            proseMirrorElement.removeEventListener('paste', handlePaste);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [
        findProseMirrorElement,
        isFeatureEnabled,
        generateTitleFromPaste
    ]);
    const onStreamingComplete = (0, $42omo.useCallback)(()=>{
        setIsTitleGenerating(false);
        setShouldShowStreaming(false);
    }, []);
    const onStreamingError = (0, $42omo.useCallback)(()=>{
        setIsTitleGenerating(false);
        setShouldShowStreaming(false);
    }, []);
    return {
        shouldGenerateTitle: isFeatureEnabled && (!title || title.trim() === '') && !isEditorEmpty,
        generateTitleFromPaste: generateTitleFromPaste,
        isTitleGenerating: isTitleGenerating,
        shouldShowStreaming: shouldShowStreaming,
        documentContext: documentContext,
        onStreamingComplete: onStreamingComplete,
        onStreamingError: onStreamingError
    };
};






var $3j1mV = parcelRequire("3j1mV");


var $kAaxz = parcelRequire("kAaxz");

var $d3UlG = parcelRequire("d3UlG");










const $28e26229a1e55e9f$var$buildTitleGenerationRequest = (contentAri, documentContext, locale, skip)=>[
        {
            ai_feature_input: {
                feature: 'suggest_title',
                feature_args: {
                    user_input: '',
                    document_context: documentContext,
                    supportedMarkdownNodes: [
                        'PARAGRAPH',
                        'HEADING',
                        'BULLET_LISTS'
                    ]
                },
                content_ari: contentAri || undefined,
                locale: locale
            }
        },
        {
            apiPath: 'v2/ai-feature/editor-ai/stream',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            enableFollowUp: false,
            enablePartialJson: false,
            skip: skip,
            headers: {
                'x-experience-id': 'editor',
                'x-product': 'confluence'
            }
        }
    ];
const $28e26229a1e55e9f$export$d25f0adcf56ef979 = ({ contentId: contentId, cloudId: cloudId, documentContext: documentContext, locale: locale, skip: skip, onTitleChange: onTitleChange })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, 'page');
    const requestOptionsRef = (0, $42omo.useRef)(null);
    if (!requestOptionsRef.current && pageAri && documentContext) requestOptionsRef.current = {
        documentContext: documentContext,
        pageAri: pageAri,
        skip: skip
    };
    // locking the request options to avoid rebuilding the request on every render
    // this is in the case the document context changes or the page ari loads from undefined to a value
    const requestOptions = requestOptionsRef.current;
    const [request, config] = (0, $42omo.useMemo)(()=>$28e26229a1e55e9f$var$buildTitleGenerationRequest(requestOptions?.pageAri ?? pageAri ?? '', requestOptions?.documentContext ?? documentContext, locale, requestOptions?.skip ?? skip), [
        requestOptions,
        pageAri,
        documentContext,
        locale,
        skip
    ]);
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                onTitleChange?.(state.content);
                experienceTracker?.succeed({
                    name: (0, $irVI7.AI_TITLE_GENERATION)
                });
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                const errorMessage = state.error?.message?.content || 'Title generation failed';
                if (!errorMessage.includes('missing valid content')) {
                    trackAIResultError({
                        aiErrorMessage: errorMessage
                    }, {
                        attributes: {
                            aiFeatureName: 'aiTitleGenOnPaste'
                        }
                    });
                    experienceTracker?.fail({
                        name: (0, $irVI7.AI_TITLE_GENERATION),
                        error: new Error(errorMessage)
                    });
                }
                break;
        }
    }, [
        onTitleChange,
        experienceTracker,
        trackAIResultError
    ]);
    const [{ content: content, responseState: responseState, error: error }] = (0, $d3UlG.useConvoAIStreaming)(request, config, onStateChange);
    return {
        content: content,
        responseState: responseState,
        error: error
    };
};


const $13620dc4c8badc82$export$2cc2619c1815701b = ({ contentId: contentId, cloudId: cloudId, title: title, userOffline: userOffline, onTitleGenerated: onTitleGenerated, onTitleGeneratingChange: onTitleGeneratingChange, isEditorEmpty: isEditorEmpty })=>{
    const { shouldShowStreaming: shouldShowStreaming, documentContext: documentContext, onStreamingComplete: onStreamingComplete, onStreamingError: onStreamingError, isTitleGenerating: isTitleGenerating } = (0, $a812429a3650bd08$export$75c1a2471a9bbe6b)({
        contentId: contentId,
        cloudId: cloudId,
        title: title,
        onTitleChange: onTitleGenerated,
        userOffline: userOffline,
        isEditorEmpty: isEditorEmpty
    });
    const { locale: locale } = (0, $8C5kA.default)();
    const hasCompletedRef = (0, $42omo.useRef)(false);
    const prevDocumentContextRef = (0, $42omo.useRef)(documentContext);
    (0, $42omo.useEffect)(()=>{
        if (documentContext !== prevDocumentContextRef.current && documentContext !== '') {
            hasCompletedRef.current = false;
            prevDocumentContextRef.current = documentContext;
        }
    }, [
        documentContext
    ]);
    const handleTitleChange = (0, $42omo.useCallback)((newTitle)=>{
        if (!hasCompletedRef.current) {
            hasCompletedRef.current = true;
            onTitleGenerated(newTitle);
        }
    }, [
        onTitleGenerated
    ]);
    const { content: content, responseState: responseState, error: error } = (0, $28e26229a1e55e9f$export$d25f0adcf56ef979)({
        contentId: contentId,
        cloudId: cloudId,
        documentContext: documentContext,
        locale: locale,
        skip: !shouldShowStreaming,
        onTitleChange: handleTitleChange
    });
    (0, $42omo.useEffect)(()=>{
        if (responseState === 'FinalResponse' && content) onStreamingComplete();
        else if (responseState === 'Error' && error) onStreamingError();
    }, [
        responseState,
        content,
        error,
        onStreamingComplete,
        onStreamingError
    ]);
    (0, $42omo.useEffect)(()=>{
        onTitleGeneratingChange?.(isTitleGenerating);
    }, [
        isTitleGenerating,
        onTitleGeneratingChange
    ]);
    return null;
};
$13620dc4c8badc82$export$2cc2619c1815701b.displayName = 'EditorTitleAIGenerationOnPaste';



var $2SWmG = parcelRequire("2SWmG");

// The duration is hard-coded in styled bc compiled css will not allow us to insert this timing dynamically. It's also slightly longer to account for easing out
const $90aadbae3b7b5d0e$var$ERROR_ANIMATION_DURATION = 1200;
const $90aadbae3b7b5d0e$export$f5770e9cb651fcf2 = 255;
const $90aadbae3b7b5d0e$export$46429ae68bc65284 = 'Cannot send metadata, currently offline.';
const $90aadbae3b7b5d0e$var$i18n = (0, $cgtv4.defineMessages)({
    blogpostTitlePlaceholder: {
        id: "editor-title.existing.blogpost.placeholder",
        defaultMessage: "Blog post title"
    },
    editorOnboardingExpTitlePlaceholderText: {
        id: "editor-title.editor.onboarding.title.placeholder",
        defaultMessage: "Give this page a title"
    },
    aiGeneratedTitleDismissButton: {
        id: "editor-title.ai.title.error.dismiss",
        defaultMessage: "Dismiss"
    },
    createBlogpostTitleDescription: {
        id: "editor-title.description.add.blogpost",
        defaultMessage: ", Add Blog Post"
    },
    editPageTitleDescription: {
        id: "editor-title.description.edit.page",
        defaultMessage: ", Edit"
    },
    createPageTitleDescription: {
        id: "editor-title.description.add.page",
        defaultMessage: ", Add Page"
    },
    createPageTemplateTitleDescription: {
        id: "editor-title.description.add.page.template",
        defaultMessage: ", Create template"
    },
    editPageTemplateTitleDescription: {
        id: "editor-title.description.edit.page.template",
        defaultMessage: ", Edit template"
    }
});
const $90aadbae3b7b5d0e$export$aafacd47ca4852d = {
    'data-ai-suggest-title-target': 'true'
};
const $90aadbae3b7b5d0e$var$AIBorderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface'
});
const $90aadbae3b7b5d0e$var$PlaceholderStyles = (0, $ecnYn.xcss)({
    // Necessary for proper editor content/title alignment
    marginTop: 'space.negative.075',
    marginBottom: 'space.050'
});
const $90aadbae3b7b5d0e$var$TitleGenerationPlaceholder = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.200"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.025"
    }));
};
$90aadbae3b7b5d0e$var$TitleGenerationPlaceholder.displayName = 'TitleGenerationPlaceholder';
const $90aadbae3b7b5d0e$export$ca74a9f12ee60773 = ()=>{
    // we manually expose here: next/packages/editor-title/src/editorTitleStyled.tsx line ~160
    if (!(0, $6mKj3.expValEquals)('platform_editor_editor_title_field_sizing', 'variant', 'test')) return false;
    return (0, $idaAv.isFieldSizingSupported)();
};
const $90aadbae3b7b5d0e$var$AI_RESULT_VIEW_TIMEOUT = 10000;
const $90aadbae3b7b5d0e$var$AI_RESULT_VIEW_TIMEOUT_THRESHOLD = 0.5;
/**
 * @todo CTE-268 typing in title is slow with in-editor templates (long term solution)
 * For now, we are solving this by debouncing calls to the onChange prop. Once the long term
 * solution is ready (see ticket for details), we should remove the debounceOnChange prop and logic
 */ class $90aadbae3b7b5d0e$var$EditorTitleComponentClass extends (0, $42omo.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.title !== state.prevTitle) return {
            title: props.title,
            prevTitle: props.title
        };
        return null;
    }
    componentDidMount() {
        const { isTemplateEditor: isTemplateEditor, title: title } = this.props;
        const { shouldFocusTitle: shouldFocusTitle } = this.state;
        const shouldTemplateEditorTitleFocus = isTemplateEditor && !title && shouldFocusTitle;
        if (shouldTemplateEditorTitleFocus) this._focusTextarea();
        this._updateHeightAuto();
        window.addEventListener('resize', this._onWindowResize);
    }
    componentDidUpdate(prevProps, prevState) {
        const { userOffline: userOffline, focusEditor: focusEditor, title: title, isInPreview: isInPreview, flagArray: flagArray, intl: intl, isTitleGeneratingFromPaste: isTitleGeneratingFromPaste, flags: flags } = this.props;
        const { focusChanged: focusChanged, shouldFocusTitle: shouldFocusTitle } = this.state;
        const userWasOffline = prevProps.userOffline && !userOffline;
        const userWasNotOffline = !prevProps.userOffline && !userOffline;
        this._updateHeightAuto();
        if (prevState.prevTitle !== title) {
            this._debouncedOnChange.cancel();
            if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                this._focusTextarea();
                // Don't add to undo stack if the change came from manual user editing
                // Add the previous title so we can undo back to it
                if (title && !this._isManualTitleChange) this._undoRedoManager.addToUndoStack(title);
                this._isManualTitleChange = false;
            }
        }
        // if user was offline
        if (userWasOffline) {
            if (focusChanged && shouldFocusTitle) this._focusTextarea();
            else focusEditor();
        }
        // if user was not offline
        if (userWasNotOffline && !title && shouldFocusTitle) this._focusTextarea();
        /** Focus title if title-related error flag:
     * We check the flags array length against that of the flags from prevProps so that
     * we can detect if a new error flag has been added. If the current length is greater
     * than the previous length, a flag was added.
     */ if (flagArray && prevProps.flagArray && flagArray.length > prevProps.flagArray.length && (this._hasTitleError() || String(flagArray[0].title) === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE)) this._onTitleError();
        if (prevProps.isTitleGeneratingFromPaste && !isTitleGeneratingFromPaste) {
            const flagMessage = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_FROM_PASTE]: true
                },
                formatMessage: intl.formatMessage
            });
            flags.hideFlag('ai-generated-title-from-paste-flag');
            flags.showCustomFlag({
                id: 'ai-generated-title-from-paste-flag',
                title: flagMessage?.title,
                description: flagMessage?.description,
                customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    paddingBlockStart: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                    label: "",
                    size: "xsmall"
                })),
                actions: [
                    {
                        content: intl.formatMessage($90aadbae3b7b5d0e$var$i18n.aiGeneratedTitleDismissButton),
                        onClick: ()=>flags.hideFlag('ai-generated-title-from-paste-flag')
                    }
                ]
            });
            this._focusTextarea();
        }
        if (!prevState.isTitleAIGenerated && this.state.isTitleAIGenerated) {
            this._originalAIGeneratedTitleLength = this.state.title?.length ?? 0;
            this._aiResultViewTimeoutId = setTimeout(()=>{
                const currentTitleLength = this.state.title?.length ?? 0;
                const originalLength = this._originalAIGeneratedTitleLength ?? 0;
                if (originalLength > 0 && currentTitleLength >= originalLength * $90aadbae3b7b5d0e$var$AI_RESULT_VIEW_TIMEOUT_THRESHOLD) this.props.trackAIResultView({
                    attributes: {
                        aiFeatureName: 'aiTitleGenOnPaste',
                        doesNotMeetMAUCriteria: true
                    }
                });
                this._originalAIGeneratedTitleLength = null;
                this._aiResultViewTimeoutId = null;
            }, $90aadbae3b7b5d0e$var$AI_RESULT_VIEW_TIMEOUT);
        }
        if (prevProps.title === title && prevProps.isInPreview === isInPreview) return;
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize); // cleanup event listener
        this._debouncedOnChange.flush();
        if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) this._undoRedoManager.clear();
        if (this._aiResultViewTimeoutId) {
            clearTimeout(this._aiResultViewTimeoutId);
            this._aiResultViewTimeoutId = null;
        }
    }
    _focusTextarea() {
        if (this._textareaRef.current) this._textareaRef.current.focus();
    }
    _updateHeightAuto() {
        // if the browser doesn't support `field-sizing: content`,
        // this needs to run to set the height of the textarea
        if (!$90aadbae3b7b5d0e$export$ca74a9f12ee60773()) {
            if (this._textareaRef.current) {
                // this line will make a reflow so that `textArea.scrollHeight` is updated with correct value.
                this._textareaRef.current.style.height = 'auto';
                this._textareaRef.current.style.height = `${this._textareaRef.current.scrollHeight}px`;
            }
        }
    }
    render() {
        const { isDisabled: isDisabled, isTitleCenterAligned: isTitleCenterAligned, isAIEnabledForContent: isAIEnabledForContent } = this.props;
        // We store local changes in state when we debounce calls to this.props.onChange.
        // So state contains the most updated title value in this case
        const title = this.props.debounceOnChange ? this.state.title : this.props.title;
        const description = this.generateDescription();
        const placeholder = this._getTitlePlaceholder();
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(window.__SSR_RENDERED__);
        const UseEditorTextAreaNext = $90aadbae3b7b5d0e$export$ca74a9f12ee60773() ? (0, $8m9SI.EditorTitleTextAreaNext) : (0, $8m9SI.EditorTitleTextArea);
        const EditorTitleTextAreaToUse = isAIEnabledForContent && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_title_generation', 'cohort', 'test') ? (0, $8m9SI.AIGeneratedEditorTitleTextArea) : UseEditorTextAreaNext;
        if (this.state.isTitleGenerating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $90aadbae3b7b5d0e$var$PlaceholderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOOm2.AIBorder), {
            loading: true,
            useModalStyles: true,
            hideGlow: true,
            customInnerContainerStyles: $90aadbae3b7b5d0e$var$AIBorderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90aadbae3b7b5d0e$var$TitleGenerationPlaceholder, null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, isSSR ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13620dc4c8badc82$export$2cc2619c1815701b), {
            contentId: this.props.contentId,
            cloudId: this.props.cloudId,
            title: this.props.title,
            userOffline: this.props.userOffline,
            onTitleGenerated: this._setTitleAI,
            onTitleGeneratingChange: this.props.onTitleGeneratingChange,
            isEditorEmpty: this.props.isEditorEmpty ?? false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0AJ7.EditorTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorTitleTextAreaToUse, {
            name: "editpages-title",
            "data-test-id": "editor-title",
            ...$90aadbae3b7b5d0e$export$aafacd47ca4852d,
            maxLength: $90aadbae3b7b5d0e$export$f5770e9cb651fcf2,
            "aria-label": placeholder,
            "aria-describedby": "editor-title-description",
            placeholder: placeholder,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $1k6sE.ALLOW_SHORTCUTS_CLASS),
            value: title || '',
            required: true,
            rows: 1,
            ref: this._textareaRef,
            onKeyDown: this._onKeyDown,
            onChange: this._onTitleChange,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            "data-gramm": false,
            disabled: isDisabled,
            shouldAnimate: this.state.shouldAnimateTitle,
            isTitleAIGenerated: this.state.isTitleAIGenerated,
            isTitleCenterAligned: isTitleCenterAligned,
            key: this.state.shouldAnimateTitle ? 'editor-title-animated' : 'editor-title'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            hidden: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            id: "editor-title-description",
            testId: "editor-title-description"
        }, description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, this.props.activeRedactionsSpotlight ?? null));
    }
    constructor(props){
        super(props);
        this._textareaRef = void 0;
        this._hasEditEventFiredRef = void 0;
        this._undoRedoManager = void 0;
        this.state = {
            title: this.props.title,
            // eslint-disable-next-line react/no-unused-state
            prevTitle: this.props.title,
            shouldFocusTitle: this.props.initialShouldFocusTitle ?? true,
            focusChanged: false,
            shouldAnimateTitle: false,
            isTitleAIGenerated: false,
            isTitleGenerating: false
        };
        this._isManualTitleChange = false;
        this._originalAIGeneratedTitleLength = null;
        this._aiResultViewTimeoutId = null;
        /**
     * Checks if the flags array has a title-relevant error
     * 1. empty title / title with only whitespace
     * 2. duplicate title
     */ this._hasTitleError = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))(()=>{
            const { flagArray: flagArray, intl: intl } = this.props;
            // These flag messages are always defined so they shouldn't return null
            const titleErrors = [
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title
            ];
            if (flagArray && flagArray.length > 0) {
                // We only want to check the most recent, incoming error in case user hasn't dismissed a previous error
                const errorMessage = String(flagArray[0].title);
                return titleErrors.includes(errorMessage);
            }
            return false;
        });
        this._debouncedOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((value)=>{
            this.props.onChange(value);
        }, (0, $1ggpj.onChangeTitleDebounceTime));
        this._onTitleChange = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, spaceId: spaceId } = this.props;
            const newTitle = event.target.value;
            // Mark this as a manual title change so we don't add to undo stack
            this._isManualTitleChange = true;
            this.setState({
                title: newTitle,
                isTitleAIGenerated: false
            });
            if (this.props.debounceOnChange) this._debouncedOnChange(newTitle);
            else this.props.onChange(newTitle);
            if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) this._undoRedoManager.clear();
            if (!this._hasEditEventFiredRef.current) {
                createAnalyticsEvent?.({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'editorTitle',
                        action: 'edited',
                        actionSubject: 'editor',
                        objectId: contentId,
                        objectType: 'page',
                        attributes: {
                            isLivePage: false,
                            editorSessionId: this.props.editorSessionId
                        },
                        containerType: 'space',
                        containerId: spaceId
                    }
                }).fire();
                this._hasEditEventFiredRef.current = true;
            }
        };
        this._onFocusChanged = (focusChanged)=>{
            this.setState({
                shouldFocusTitle: focusChanged,
                focusChanged: true
            });
            this.props.onFocusChanged(focusChanged);
        };
        this._setTitleAI = (newTitle)=>{
            this.setState({
                isTitleGenerating: false,
                title: newTitle,
                isTitleAIGenerated: true
            });
            this.props.onChange(newTitle);
        };
        this._undoAIGeneratedTitle = ()=>{
            const { title: title } = this.state;
            const currentTitle = title || '';
            const previousState = this._undoRedoManager.undo(currentTitle);
            if (currentTitle === previousState) return;
            this.setState({
                title: previousState,
                isTitleAIGenerated: false,
                prevTitle: title
            });
            this.props.onChange(previousState);
        };
        this._redoAIGeneratedTitle = ()=>{
            const { title: title } = this.state;
            const currentTitle = title || '';
            const nextState = this._undoRedoManager.redo(currentTitle);
            if (currentTitle === nextState) return;
            this.setState({
                title: nextState,
                isTitleAIGenerated: false,
                prevTitle: title
            });
            this.props.onChange(nextState);
        };
        this.generateTitle = ()=>{
            const { trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIInteractionInit: trackAIInteractionInit, setGeneratedTitle: setGeneratedTitle, setTrackAIResultViewStored: setTrackAIResultViewStored, experienceTracker: experienceTracker, userOffline: userOffline, flags: flags, intl: intl } = this.props;
            if (userOffline) return;
            const filteredProseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]'));
            const targetEditorId = filteredProseMirrors[0]?.dataset?.editorId;
            const handleAiTitleError = ({ errorMessage: errorMessage, errorCode: errorCode = 500 })=>{
                this._setTitleAI('');
                trackAIResultError({
                    aiErrorMessage: errorMessage,
                    aiErrorCode: errorCode
                });
                if (errorMessage === $90aadbae3b7b5d0e$export$46429ae68bc65284) // Abort rather than fail because the editor being offline
                // should not be attributed to AI Title Generation experience failure
                experienceTracker.abort({
                    name: (0, $irVI7.AI_TITLE_GENERATION),
                    reason: 'Editor offline'
                });
                else experienceTracker.fail({
                    name: (0, $irVI7.AI_TITLE_GENERATION),
                    error: new Error(errorMessage)
                });
                this.setState({
                    isTitleGenerating: false
                });
                const errorFlagMessage = (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]: true
                    },
                    formatMessage: intl.formatMessage
                });
                flags.hideFlag('ai-generated-title-flag');
                flags.showErrorFlag({
                    id: 'ai-generated-title-error-flag',
                    title: errorFlagMessage?.title,
                    description: errorFlagMessage?.description,
                    actions: [
                        {
                            content: intl.formatMessage($90aadbae3b7b5d0e$var$i18n.aiGeneratedTitleDismissButton),
                            onClick: ()=>flags.hideFlag('ai-generated-title-error-flag')
                        }
                    ]
                });
            };
            let generatedTitle = '';
            if (targetEditorId) {
                trackAIInteractionInit();
                setTrackAIResultViewStored?.(trackAIResultView);
                experienceTracker.start({
                    name: (0, $irVI7.AI_TITLE_GENERATION)
                });
                (0, $jOIil.eventHub).publishToEditor({
                    event: 'start prompt',
                    data: {
                        targetEditorId: targetEditorId,
                        analyticSourceId: 'confluenceTitleGenOnPublish',
                        prompt: 'suggest title',
                        hideModal: true,
                        streamingCallback: (data)=>{
                            switch(data.type){
                                case 'initialising':
                                    this.setState({
                                        isTitleGenerating: true
                                    });
                                    break;
                                case 'streaming':
                                    generatedTitle = data.result?.trim() ?? '';
                                    if (generatedTitle) this._setTitleAI(generatedTitle);
                                    break;
                                case 'complete':
                                    generatedTitle = data.result?.trim() ?? '';
                                    if (generatedTitle) {
                                        this._setTitleAI(generatedTitle);
                                        trackAIResultView({
                                            doesNotMeetMAUCriteria: true
                                        });
                                        experienceTracker.succeed({
                                            name: (0, $irVI7.AI_TITLE_GENERATION)
                                        });
                                        setGeneratedTitle?.(generatedTitle);
                                    } else handleAiTitleError({
                                        errorMessage: 'Generated title is empty'
                                    });
                                    break;
                                case 'error':
                                    handleAiTitleError({
                                        errorMessage: data.errorInfo?.errorContent,
                                        errorCode: data.errorInfo?.statusCode
                                    });
                                    break;
                            }
                        }
                    }
                });
            }
        };
        this.generateDescription = ()=>{
            const { intl: { formatMessage: formatMessage }, contentType: contentType, isTemplateEditor: isTemplateEditor, isUnpublishedDraft: isUnpublishedDraft } = this.props;
            if (isUnpublishedDraft) {
                if (isTemplateEditor) return formatMessage($90aadbae3b7b5d0e$var$i18n.createPageTemplateTitleDescription);
                else return contentType === 'blogpost' ? formatMessage($90aadbae3b7b5d0e$var$i18n.createBlogpostTitleDescription) : formatMessage($90aadbae3b7b5d0e$var$i18n.createPageTitleDescription);
            } else return isTemplateEditor ? formatMessage($90aadbae3b7b5d0e$var$i18n.editPageTemplateTitleDescription) : formatMessage($90aadbae3b7b5d0e$var$i18n.editPageTitleDescription);
        };
        this._onTitleError = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, flagArray: flagArray, intl: intl, contentId: contentId, spaceId: spaceId, isAIEnabledForContent: isAIEnabledForContent } = this.props;
            const flagTitle = String(flagArray?.[0]?.title);
            const titleRequiredFlagTitle = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]: true
                },
                formatMessage: intl.formatMessage
            })?.title;
            const aiGeneratedTitleFlagTitle = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                },
                formatMessage: intl.formatMessage
            })?.title;
            if (flagArray && (flagTitle === titleRequiredFlagTitle || flagTitle === aiGeneratedTitleFlagTitle)) createAnalyticsEvent?.({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorTitle',
                    action: 'publishAttemptedEmptyTitle',
                    actionSubject: 'editor',
                    objectId: contentId,
                    objectType: 'page',
                    attributes: {
                        isLivePage: false,
                        isAiTitleEnabled: String(flagArray?.[0]?.title) === (0, $cHfGW.buildEditorFlagMessage)({
                            errorData: {
                                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                            },
                            formatMessage: intl.formatMessage
                        })?.title
                    },
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            if (flagArray && String(flagArray?.[0]?.title) === (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                },
                formatMessage: intl.formatMessage
            })?.title && isAIEnabledForContent && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) {
                this._focusTextarea();
                this.generateTitle();
            } else {
                this._focusTextarea();
                this.setState({
                    shouldAnimateTitle: true
                });
                /*
         * Additional focus needed after animation bc setting the shouldAnimateTitle state will change the key of the textArea,
         * which means re-render will regenerate entire view, causing loss of focus
         */ setTimeout(()=>{
                    this.setState({
                        shouldAnimateTitle: false
                    });
                    this._focusTextarea();
                }, $90aadbae3b7b5d0e$var$ERROR_ANIMATION_DURATION);
            }
        };
        this._getTitlePlaceholder = ()=>{
            const { contentType: contentType, intl: intl, customPlaceholder: customPlaceholder } = this.props;
            if (customPlaceholder) return customPlaceholder;
            return contentType === 'blogpost' ? intl.formatMessage($90aadbae3b7b5d0e$var$i18n.blogpostTitlePlaceholder) : intl.formatMessage($90aadbae3b7b5d0e$var$i18n.editorOnboardingExpTitlePlaceholderText);
        };
        this._onFocus = ()=>{
            this._onFocusChanged(true);
        };
        this._onBlur = ()=>{
            this.props.onTitleBlur(this.state.title ?? undefined);
            this._onFocusChanged(false);
        };
        /**
     * Triggered from window resize event listener
     */ this._onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            this._updateHeightAuto();
        }, 200);
        this._onKeyDown = (event)=>{
            // If the user is composing characters using, e.g., the Hiragana - Kana keyboard,
            // short circuit the code to prevent the bug in Chrome where the selected text
            // gets copied into the editor body.
            if (event.nativeEvent.isComposing) return;
            // This is for an undo/redo shortcut for AI-generated titles
            if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                const modifierKey = (0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey;
                const isUndoShortcut = event.key === 'z' && modifierKey && !event.shiftKey;
                const isRedoShortcut = event.key === 'z' && modifierKey && event.shiftKey;
                if (isUndoShortcut && this._undoRedoManager.canUndo()) {
                    event.preventDefault();
                    event.stopPropagation();
                    this._undoAIGeneratedTitle();
                    return;
                }
                if (isRedoShortcut && this._undoRedoManager.canRedo()) {
                    event.preventDefault();
                    event.stopPropagation();
                    this._redoAIGeneratedTitle();
                    return;
                }
            }
            // Shift+Tab should not be prevented, so we check if tab pressed without shift
            const isTabPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).TAB.key && !event.shiftKey;
            // If enter is pressed without publish keyboard shortcut prompt key, prevent default and insert newline in editor body
            const promptKeyForPublishShortcut = (0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey;
            const isEnterPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).ENTER.key && !promptKeyForPublishShortcut;
            const isDownArrowPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).DOWN.key;
            if (isTabPressed || isEnterPressed || isDownArrowPressed) {
                event.preventDefault();
                event.stopPropagation();
                if (this.props.isTemplatesSuggestionsEnabled && this.props.templateButtonRef?.current) this.props.templateSuggestionsRef?.current?.focus();
                else {
                    const { editorApi: editorApi } = this.props;
                    if (isEnterPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.insertNewLineAtDocStart());
                    if (isTabPressed || isDownArrowPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.selectDocStart());
                    this.props.focusEditor();
                }
            }
        };
        this._textareaRef = /*#__PURE__*/ (0, $42omo.createRef)();
        this._hasEditEventFiredRef = {
            current: false
        };
        this._undoRedoManager = new (0, $2SWmG.UndoRedoManager)();
    // Don't add initial title to undo stack - only add when title is about to change
    }
}
function $90aadbae3b7b5d0e$var$aiAnalyticsEvents(WrappedComponent) {
    const WithAIAnalyticsFn = function WithAIAnalytics(props) {
        const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            trackAIInteractionInit: trackAIInteractionInit,
            trackAIResultError: trackAIResultError,
            trackAIResultView: trackAIResultView
        });
    };
    WithAIAnalyticsFn.displayName = 'WithAIAnalytics';
    return WithAIAnalyticsFn;
}
const $90aadbae3b7b5d0e$var$redactionsChangeboarding = (WrappedComponent)=>(props)=>{
        const { contentId: contentId, title: title } = props;
        (0, $2MwVI.useTrackTitleRedactionRendered)({
            contentId: contentId,
            title: title
        });
        const { activeSpotlight: activeSpotlight } = (0, $iuuqT.useRedactionsTour)({
            contentId: contentId,
            step: (0, $kycWk.RedactionsTourSteps).FIRST,
            firstStepSource: (0, $iuuqT.RedactionTourStepSource).titleRedaction
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            activeRedactionsSpotlight: activeSpotlight
        });
    };
$90aadbae3b7b5d0e$var$redactionsChangeboarding.displayName = 'RedactionsChangeboarding';
const $90aadbae3b7b5d0e$var$experienceTracking = (WrappedComponent)=>(props)=>{
        const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
$90aadbae3b7b5d0e$var$experienceTracking.displayName = 'ExperienceTracking';
const $90aadbae3b7b5d0e$export$813a56baf1599592 = //Adding HOC since flagArray is needed to trigger componentDidUpdate
(0, $7aRa9.withFlags)((0, $7mpOv.withIsAIEnabledForContent)((0, $gmMgo.default)($90aadbae3b7b5d0e$var$experienceTracking($90aadbae3b7b5d0e$var$redactionsChangeboarding($90aadbae3b7b5d0e$var$aiAnalyticsEvents((0, $1DWH0.default)()($90aadbae3b7b5d0e$var$EditorTitleComponentClass)))))));
$90aadbae3b7b5d0e$export$813a56baf1599592.displayName = 'EditorTitle';
module.exports["MAX_LENGTH_OF_TITLE"] = $90aadbae3b7b5d0e$export$f5770e9cb651fcf2;
module.exports["AI_SUGGEST_TITLE_PROPS"] = $90aadbae3b7b5d0e$export$aafacd47ca4852d;
module.exports["fieldSizingEnabled"] = $90aadbae3b7b5d0e$export$ca74a9f12ee60773;
module.exports["EditorTitle"] = $90aadbae3b7b5d0e$export$813a56baf1599592;

});

parcelRegister("8m9SI", function(module, exports) {
/* editorTitleStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fTmNK = parcelRequire("fTmNK");

const $d2d5c3ff61979fcc$var$shakeAnimation = null;
const $d2d5c3ff61979fcc$var$fadeUnderlineAnimation = null;
const $d2d5c3ff61979fcc$export$37076bfbe5bc34e4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAnimate: shouldAnimate, isTitleCenterAligned: isTitleCenterAligned, isDisabledTextBlack: isDisabledTextBlack, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c812ln _19itglyw _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug _j7hqs4gh _1pgl1ytf _bfhk1kw7 _k48pi7a9 _4t3i1wug _1e0c1ule _1bto1l2s _14zgglyw _o5721jtm _vchhusvi _19pkidpf _1bsb1osq _12tii7uo _cun91j28 _1goxglyw _13xeglyw _h9ziglyw _1idr1rpy _1wfakb7n _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.shouldAnimate ? "_5sag9cwz" : "_5sag5cps",
            __cmplp.isTitleCenterAligned ? "_y3gn1h6o" : "_y3gn18uv",
            __cmplp.isDisabledTextBlack ? "_vbqbi7uo" : "_vbqb1gmx",
            __cmplp.isTitleCenterAligned ? "_sdir1h6o" : "_sdir18uv",
            __cmplp.className
        ])
    });
});
$d2d5c3ff61979fcc$export$37076bfbe5bc34e4.displayName = 'EditorTitleTextArea'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $d2d5c3ff61979fcc$export$4b3be882d63e1514 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $d2d5c3ff61979fcc$export$37076bfbe5bc34e4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0t1edp",
            __cmplp.className
        ])
    });
});
$d2d5c3ff61979fcc$export$4b3be882d63e1514.displayName = 'EditorTitleTextAreaNext';
const $d2d5c3ff61979fcc$var$aiGeneratedStyle = null;
const $d2d5c3ff61979fcc$export$7efa51f4cf8cfb64 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isTitleAIGenerated: isTitleAIGenerated = false, ...props }, ref)=>{
    if ((0, $fTmNK.fieldSizingEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2d5c3ff61979fcc$export$4b3be882d63e1514, {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            isTitleAIGenerated && "",
            isTitleAIGenerated && "_j7hq1bgo _5sag12me _7hjf1v3l"
        ])
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2d5c3ff61979fcc$export$37076bfbe5bc34e4, {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            isTitleAIGenerated && "",
            isTitleAIGenerated && "_j7hq1bgo _5sag12me _7hjf1v3l"
        ])
    });
});
$d2d5c3ff61979fcc$export$7efa51f4cf8cfb64.displayName = 'AIGeneratedEditorTitleTextArea';
module.exports["EditorTitleTextArea"] = $d2d5c3ff61979fcc$export$37076bfbe5bc34e4;
module.exports["EditorTitleTextAreaNext"] = $d2d5c3ff61979fcc$export$4b3be882d63e1514;
module.exports["AIGeneratedEditorTitleTextArea"] = $d2d5c3ff61979fcc$export$7efa51f4cf8cfb64;

});

parcelRegister("i0AJ7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $584dfcc5531b805f$var$containerBaseStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    flexDirection: 'column',
    gap: 'space.075',
    width: '100%',
    marginBottom: 'initial',
    marginTop: 'space.025'
});
const $584dfcc5531b805f$export$9a8b9ed43da05bcf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "editor-title-container",
        "data-test-id": "editor-title-container",
        id: "editor-title-id",
        xcss: [
            $584dfcc5531b805f$var$containerBaseStyles
        ]
    }, children);
$584dfcc5531b805f$export$9a8b9ed43da05bcf.displayName = 'EditorTitleContainer';
module.exports["EditorTitleContainer"] = $584dfcc5531b805f$export$9a8b9ed43da05bcf;

});

parcelRegister("idaAv", function(module, exports) {
/**
 * Checks if the browser supports the field-sizing CSS property
 */ const $91f723cc1d918a38$export$a533e379d25c784e = ()=>{
    return CSS.supports('field-sizing', 'content');
};
module.exports["isFieldSizingSupported"] = $91f723cc1d918a38$export$a533e379d25c784e;

});

parcelRegister("2SWmG", function(module, exports) {
const $65022a69dfe103a5$var$DEFAULT_MAX_STACK_SIZE = 50;
class $65022a69dfe103a5$export$2aef42d075d45ec5 {
    trimStack(stack) {
        while(stack.length > this.maxStackSize)stack.shift();
    }
    addToUndoStack(title) {
        // Don't add duplicate consecutive states (compare by title)
        const lastState = this.undoStack[this.undoStack.length - 1];
        if (!lastState || lastState !== title) {
            this.undoStack.push(title);
            this.trimStack(this.undoStack);
        }
    }
    undo(currentTitle) {
        if (this.undoStack.length === 0) return currentTitle;
        // Peek at the top of the stack - if it's the same title as current state, skip it
        while(this.undoStack.length > 0 && this.undoStack[this.undoStack.length - 1] === currentTitle)this.undoStack.pop();
        if (this.undoStack.length === 0) return currentTitle;
        const previousState = this.undoStack.pop();
        // Only add to redo stack if the titles are different
        if (previousState !== currentTitle) {
            this.redoStack.push(currentTitle);
            this.trimStack(this.redoStack);
        }
        return previousState;
    }
    redo(currentTitle) {
        if (this.redoStack.length > 0) {
            const nextState = this.redoStack.pop();
            // Only add to undo stack if the titles are different
            if (nextState !== currentTitle) {
                this.undoStack.push(currentTitle);
                this.trimStack(this.undoStack);
            }
            return nextState;
        }
        return currentTitle;
    }
    canUndo() {
        return this.undoStack.length > 0;
    }
    canRedo() {
        return this.redoStack.length > 0;
    }
    clear() {
        this.undoStack = [];
        this.redoStack = [];
    }
    constructor(maxStackSize = $65022a69dfe103a5$var$DEFAULT_MAX_STACK_SIZE){
        this.undoStack = [];
        this.redoStack = [];
        this.maxStackSize = void 0;
        this.maxStackSize = maxStackSize;
    }
}
module.exports["UndoRedoManager"] = $65022a69dfe103a5$export$2aef42d075d45ec5;

});

parcelRegister("5epXp", function(module, exports) {
/* EditorTitleWithTitleAreaComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $xQxzY = parcelRequire("xQxzY");


var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $iu6m9 = parcelRequire("iu6m9");


var $gr7Mm = parcelRequire("gr7Mm");


var $bKd7w = parcelRequire("bKd7w");


var $3WPGR = parcelRequire("3WPGR");


var $gTAwR = parcelRequire("gTAwR");


var $b3j2Y = parcelRequire("b3j2Y");


var $ktUCG = parcelRequire("ktUCG");


var $bJX6u = parcelRequire("bJX6u");


var $cxu5H = parcelRequire("cxu5H");


var $5vi32 = parcelRequire("5vi32");


var $gqqjz = parcelRequire("gqqjz");


var $2HGN8 = parcelRequire("2HGN8");


var $5DJsZ = parcelRequire("5DJsZ");


var $7PLO8 = parcelRequire("7PLO8");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $luv00 = parcelRequire("luv00");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");


var $bMPhU = parcelRequire("bMPhU");


var $jMyy4 = parcelRequire("jMyy4");


var $f7B1p = parcelRequire("f7B1p");

const $239d2520a432cbe7$var$sanitizeUrl = (url)=>url.replace(/[^\w\-/.:%?=]+/g, '');
async function $239d2520a432cbe7$export$91130da4da46566b({ title: title, locale: locale }) {
    return (0, $f7B1p.cfetch)('/gateway/api/assist/chat/v1/invoke_agent', {
        method: 'POST',
        headers: {
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'editor',
            'x-product': 'confluence'
        },
        body: JSON.stringify({
            recipient_agent_named_id: 'editor_intent_agent',
            agent_input_context: {
                // eslint-disable-next-line
                content_url: $239d2520a432cbe7$var$sanitizeUrl(document.location.href),
                writing_intent: 'unsplash_header_image.json',
                draft_full_content: title,
                draft_selected_content: undefined,
                supported_markdown_nodes: [
                    'PARAGRAPH',
                    'BULLET_LISTS',
                    'NUMBERED_LISTS',
                    'HEADING',
                    'BLOCKQUOTES',
                    'CODEBLOCKS',
                    'HORIZONTAL_RULE',
                    'TABLE',
                    'IMAGES',
                    'TASK_LIST',
                    'LINK',
                    'ITALICS',
                    'BOLD',
                    'STRIKETHROUGH',
                    'CODE_SPAN'
                ],
                input_mime_type: 'text/markdown',
                output_mime_type: 'text/markdown',
                locale: locale,
                product: 'CONFLUENCE'
            }
        })
    }).then((response)=>response.json()).then((responseData)=>{
        return responseData.message.content;
    });
}


/* TitleSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $8z0fF = parcelRequire("8z0fF");


var $3jwuS = parcelRequire("3jwuS");


var $75Ax4 = parcelRequire("75Ax4");


var $jVylI = parcelRequire("jVylI");




const $d765f449481d5188$var$mainBoxStylesBase = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
});
const $d765f449481d5188$var$mainBoxStylesGapSpace0 = (0, $ecnYn.xcss)({
    gap: 'space.0'
});
const $d765f449481d5188$var$mainBoxStylesGapSpace300 = (0, $ecnYn.xcss)({
    gap: 'space.300'
});
const $d765f449481d5188$var$titleBoxStylesBase = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '100%'
});
const $d765f449481d5188$var$titleBoxStylesDisplayFlex = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $d765f449481d5188$var$titleBoxStylesFlexDirectionColumn = (0, $ecnYn.xcss)({
    flexDirection: 'column'
});
const $d765f449481d5188$var$titleBoxStylesFlexDirectionInitial = (0, $ecnYn.xcss)({
    flexDirection: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesGapSpace300 = (0, $ecnYn.xcss)({
    gap: 'space.300'
});
const $d765f449481d5188$var$titleBoxStylesMarginTopMinus90px = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px'
});
const $d765f449481d5188$var$titleBoxStylesMarginTopInitial = (0, $ecnYn.xcss)({
    marginTop: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesMarginBottomInitial = (0, $ecnYn.xcss)({
    marginBottom: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesAlignItemsCenter = (0, $ecnYn.xcss)({
    alignItems: 'center'
});
const $d765f449481d5188$var$titleBoxStylesAlignItemsInitial = (0, $ecnYn.xcss)({
    alignItems: 'initial'
});
const $d765f449481d5188$var$contentTopperBoxStylesBase = (0, $ecnYn.xcss)({
    alignSelf: 'normal'
});
const $d765f449481d5188$var$contentTopperBoxStylesMarginTopSpaceNegative300 = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.300'
});
const $d765f449481d5188$var$emojiHiddenStyles = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $d765f449481d5188$var$emojiHeightStyles = (0, $ecnYn.xcss)({
    height: '88px'
});
const $d765f449481d5188$var$marginTopSpace0Styles = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d765f449481d5188$var$EmojiTitleSelectionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_1e0c1txw" : "_1e0c18uv",
            __cmplp.isTitleCenterAligned ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned ? "_4cvr1h6o" : "_4cvr4jg8",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.hasCoverPicture ? "_1bsb1ns9" : "_1bsb1wug",
            __cmplp.hasCoverPicture && (__cmplp.hasEmoji || __cmplp.isSpaceOverview) ? "_19pk1uiu" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
$d765f449481d5188$var$EmojiTitleSelectionWrapper.displayName = 'EmojiTitleSelectionWrapper';
const $d765f449481d5188$var$baseEditorTitleStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $d765f449481d5188$var$fixedWidthLeftAlignImageStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $75Ax4.COVER_IMAGE_FIXED_WIDTH)}px`,
    margin: '0 auto',
    paddingLeft: 'space.250'
});
const $d765f449481d5188$export$718e92491c44b3f6 = ({ contentId: contentId, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, editorTitle: editorTitle, isTemplateEditor: isTemplateEditor, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isRemovingEmoji: isRemovingEmoji, contentTopperComponent: contentTopperComponent, isReadOnly: isReadOnly, coverPictureWidth: coverPictureWidth, isPageContentFullWidth: isPageContentFullWidth, isTitleAlignmentLoading: isTitleAlignmentLoading, isSpaceOverview: isSpaceOverview, pageTitleContent: pageTitleContent, autoPageEmojiCohort: autoPageEmojiCohort, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, emojiTitleDiscovered: emojiTitleDiscovered, contentType: contentType })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isNewEditorBylineLayout = isLivePage || !isSpaceOverview && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline');
    const isContentTopperLayout = isTitleCenterAligned || hasCoverPicture;
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const marginTopStyleForTitleWithCoverPicture = hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesMarginTopMinus90px : $d765f449481d5188$var$titleBoxStylesMarginTopInitial;
    const titleXcss = [
        $d765f449481d5188$var$titleBoxStylesBase,
        // display
        $d765f449481d5188$var$titleBoxStylesDisplayFlex,
        // flexDirection
        isTitleCenterAligned || hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesFlexDirectionColumn : $d765f449481d5188$var$titleBoxStylesFlexDirectionInitial,
        // gap
        isTitleCenterAligned && hasEmoji && !hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesGapSpace300 : undefined,
        // marginBottom
        $d765f449481d5188$var$titleBoxStylesMarginBottomInitial,
        // alignItems
        hasCoverPicture && isTitleCenterAligned ? $d765f449481d5188$var$titleBoxStylesAlignItemsCenter : $d765f449481d5188$var$titleBoxStylesAlignItemsInitial,
        // marginTop
        marginTopStyleForTitleWithCoverPicture
    ];
    const titleSectionStyles = [
        $d765f449481d5188$var$mainBoxStylesBase,
        !hasCoverPicture ? $d765f449481d5188$var$mainBoxStylesGapSpace0 : $d765f449481d5188$var$mainBoxStylesGapSpace300
    ];
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: titleSectionStyles
    }, !isContentTopperLayout && !isNewEditorBylineLayout && contentTopperComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    ), {
        xcss: titleXcss,
        testId: isTitleCenterAligned ? 'title-wrapper-centered' : 'title-wrapper'
    }, !isTemplateEditor && (!isRemovingEmoji || hasCoverPicture) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            hasCoverPicture && $d765f449481d5188$var$emojiHeightStyles,
            isRemovingEmoji && hasCoverPicture && $d765f449481d5188$var$emojiHiddenStyles,
            $d765f449481d5188$var$marginTopSpace0Styles,
            hasCoverPicture && isFixedWidth && isPageContentFullWidth && !isTitleCenterAligned && $d765f449481d5188$var$fixedWidthLeftAlignImageStyles
        ]
    }, isTitleAlignmentLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d765f449481d5188$var$EmojiTitleSelectionWrapper, {
        "data-testid": isTitleCenterAligned ? 'emoji-title-selection-wrapper-centered' : 'emoji-title-selection-wrapper',
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        isSpaceOverview: isSpaceOverview
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z0fF.EmojiTitleSelection), {
        contentId: contentId,
        onUpdateStartEmoji: onUpdateStartEmoji,
        onUpdateEndEmoji: onUpdateEndEmoji,
        isTitleDisabled: isTitleDisabled,
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: !!hasCoverPicture,
        linkCreation: linkCreation,
        isReadOnly: isReadOnly,
        hasInitialEmoji: hasEmoji,
        pageTitleContent: pageTitleContent,
        autoPageEmojiCohort: autoPageEmojiCohort,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        emojiTitleDiscovered: emojiTitleDiscovered,
        contentType: contentType
    }))), isContentTopperLayout && !isNewEditorBylineLayout && contentTopperComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $d765f449481d5188$var$contentTopperBoxStylesBase,
            (hasCoverPicture || hasEmoji && !isRemovingEmoji) && !isSpaceOverview && $d765f449481d5188$var$contentTopperBoxStylesMarginTopSpaceNegative300
        ]
    }, contentTopperComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $d765f449481d5188$var$baseEditorTitleStyles
        ]
    }, editorTitle))));
};
$d765f449481d5188$export$718e92491c44b3f6.displayName = 'TitleSection';


/* ToolbarAboveTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $inPa6 = parcelRequire("inPa6");







var $e4o8D = parcelRequire("e4o8D");


var $5RPbY = parcelRequire("5RPbY");





var $eToX6 = parcelRequire("eToX6");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");








var $6mKj3 = parcelRequire("6mKj3");


var $3IBnw = parcelRequire("3IBnw");








var $7mpOv = parcelRequire("7mpOv");


var $bUiJC = parcelRequire("bUiJC");


var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("bksM6"));
        return EditorContentModeButton;
    }
});






var $9hlns = parcelRequire("9hlns");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




const $49c1e00e32a75d2d$var$rainbowGradientKeyframes = null;
const $49c1e00e32a75d2d$var$rainbowGradient = null;
const $49c1e00e32a75d2d$var$container = null;
const $49c1e00e32a75d2d$export$388cb1c811714c72 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "animated-loading-gradient",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4t3i1osq _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_11q71s2s _y44v1sha _4t3i1osq _1bsb1osq _1lrwon4i _kdam1iql"
            ])
        })
    });
};









const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("3Y0iy"));
        return EditorPageCoverPictureEntry;
    }
});


const $b7b9e49b2b71ddf8$var$coverPictureAndButtonWithCoverPictureAreaBoxStyles = (0, $ecnYn.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});
const $b7b9e49b2b71ddf8$var$coverPictureAndButtonWithoutCoverPictureAreaBoxStyles = (0, $ecnYn.xcss)({
    width: 'unset',
    marginBottom: 'unset'
});
const $b7b9e49b2b71ddf8$var$coverPictureAndButtonWithFloatingToolbarBoxStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.0',
    display: 'flex',
    justifyContent: 'center'
});
const $b7b9e49b2b71ddf8$var$coverPictureAndButtonWithFloatingToolbarAndUploadingBoxStyles = (0, $ecnYn.xcss)({
    opacity: 0
});
const $b7b9e49b2b71ddf8$var$coverPictureAndButtonWithoutFloatingToolbarAndUploadingBoxStyles = (0, $ecnYn.xcss)({
    opacity: 1
});
const $b7b9e49b2b71ddf8$var$uploadingPictureBoxStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    position: 'relative'
});
const $b7b9e49b2b71ddf8$export$bd378463497634f0 = ({ contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, updateHeight: updateHeight, currentHeight: currentHeight, isReadOnly: isReadOnly, spaceKey: spaceKey, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, isAIUnsplashImage: isAIUnsplashImage, isUnsplash: isUnsplash, dynamicCoverImageHeight: dynamicCoverImageHeight, width: width, coverImageWidth: coverImageWidth, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus })=>{
    const heightChangeThreshold = 4;
    (0, $42omo.useEffect)(()=>{
        if (updateHeight && currentHeight && dynamicCoverImageHeight && Math.abs(currentHeight - dynamicCoverImageHeight) > heightChangeThreshold) updateHeight(dynamicCoverImageHeight);
    }, [
        updateHeight,
        currentHeight,
        dynamicCoverImageHeight
    ]);
    const coverPictureAndButtonXcss = [];
    if (isUploadingPicture || hasCoverPicture) coverPictureAndButtonXcss.push($b7b9e49b2b71ddf8$var$coverPictureAndButtonWithCoverPictureAreaBoxStyles);
    else coverPictureAndButtonXcss.push($b7b9e49b2b71ddf8$var$coverPictureAndButtonWithoutCoverPictureAreaBoxStyles);
    coverPictureAndButtonXcss.push($b7b9e49b2b71ddf8$var$coverPictureAndButtonWithFloatingToolbarBoxStyles);
    if (isUploadingPicture) coverPictureAndButtonXcss.push($b7b9e49b2b71ddf8$var$coverPictureAndButtonWithFloatingToolbarAndUploadingBoxStyles);
    else coverPictureAndButtonXcss.push($b7b9e49b2b71ddf8$var$coverPictureAndButtonWithoutFloatingToolbarAndUploadingBoxStyles);
    const isGeneratingHeaderImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const uploadingPictureInlineCss = {
        width: width && !isFixedWidthImageOption ? `${width}px` : '100%',
        height: `${dynamicCoverImageHeight}px`,
        position: isFixedWidthImageOption ? 'relative' : 'absolute',
        // This is a dynamic value so tokens cannot be used here
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '0px'
    };
    const LoadingIndicator = ()=>{
        // isGeneratingHeaderImage will always be false when the experiment is off,
        // but evaluating here anyway for additional safety
        if (isGeneratingHeaderImage && (0, $6mKj3.isExperimentEnabled)('confluence_aifc_header_image_generation_experiment')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49c1e00e32a75d2d$export$388cb1c811714c72), null);
        if (!isAIUnsplashImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            testId: "CoverPictureAndButton-Spinner"
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isUploadingPicture && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b7b9e49b2b71ddf8$var$uploadingPictureBoxStyles,
        testId: "uploading-picture-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: uploadingPictureInlineCss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LoadingIndicator, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: coverPictureAndButtonXcss,
        testId: "cover-picture-and-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ff4f509ac781670$export$e8a47c72fec9e984), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        isFixedWidthImageOption: isFixedWidthImageOption,
        width: coverImageWidth,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        spaceKey: spaceKey,
        hasCoverPicture: hasCoverPicture,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        isUnsplash: isUnsplash,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    })));
};















const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("7833H"))).EmojiTitleButton
});


const $8ea2840cbc0b61fe$export$e6ce3311a4d41b7f = ({ contentId: contentId, userOffline: userOffline, isTitleDisabled: isTitleDisabled, isUnpublishedDraft: isUnpublishedDraft, setSelectedEmoji: setSelectedEmoji, onEmojiPickerLoaded: onEmojiPickerLoaded, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentType: contentType, autoPageEmojiCohort: autoPageEmojiCohort, emojiTitleDiscovered: emojiTitleDiscovered })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnMouseEnter = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                source: 'EmojiTitleSection',
                actionSubject: 'pageTitle',
                actionSubjectId: 'emojiButton',
                attributes: {
                    element: 'div'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMouseLeave = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'not:hovered',
                source: 'EmojiTitleSection',
                actionSubject: 'pageTitle',
                actionSubjectId: 'emojiButton',
                attributes: {
                    element: 'div'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "emoji-title-hover-button-wrapper",
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c67d43e155b2cd3$export$8ce5c583c1fa5a96), {
        isUnpublishedDraft: isUnpublishedDraft,
        setSelectedEmoji: setSelectedEmoji,
        onEmojiPickerLoaded: onEmojiPickerLoaded,
        disableEmoji: userOffline,
        contentId: contentId,
        isTitleDisabled: isTitleDisabled,
        onUpdateStartEmoji: onUpdateStartEmoji,
        onUpdateEndEmoji: onUpdateEndEmoji,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        contentType: contentType,
        autoPageEmojiCohort: autoPageEmojiCohort,
        emojiTitleDiscovered: emojiTitleDiscovered
    }));
};












var $jkVM2 = parcelRequire("jkVM2");


var $ep3mz = parcelRequire("ep3mz");


var $38qvz = parcelRequire("38qvz");

const $770cae54ba9545b3$export$826c215475ad6cbb = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, hasContentState: hasContentState, contentType: contentType, userOffline: userOffline, setIsContentStateButtonFocused: setIsContentStateButtonFocused, setIsContentStateMenuOpen: setIsContentStateMenuOpen, floatingToolbarButtonStyle: floatingToolbarButtonStyle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isKnowledgeBaseSpace: isKnowledgeBaseSpace } = (0, $38qvz.useSpaceType)({
        spaceKey: spaceKey
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateButtonClicked',
                source: 'editorContentStateButton'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateButtonHovered',
                source: 'editorContentStateButton'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const handleFocus = (0, $42omo.useCallback)(()=>{
        setIsContentStateButtonFocused(true);
    }, [
        setIsContentStateButtonFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        setIsContentStateButtonFocused(false);
    }, [
        setIsContentStateButtonFocused
    ]);
    // only want to show hover button if we don't have a content state and if not in a knowledge base space
    // otherwise it will be next to the full-width button
    return !hasContentState && !isKnowledgeBaseSpace ? // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "content-state-button-wrapper",
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
        contentId: contentId,
        contentType: contentType,
        userOffline: userOffline,
        onContentStateMenuToggle: setIsContentStateMenuOpen,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle
    })) : null;
});



var $gektR = parcelRequire("gektR");


var $cgtv4 = parcelRequire("cgtv4");







var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $lAFHW = parcelRequire("lAFHW");


var $jOIil = parcelRequire("jOIil");







const $27a594aa59e1555a$var$i18n = (0, $cgtv4.defineMessages)({
    suggestTitleLabel: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.label",
        defaultMessage: "Suggest title"
    },
    suggestTitleTooltipWhenDocEmpty: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.empty-document.tooltip",
        defaultMessage: "Page cannot be empty"
    },
    suggestTitleTooltipWhenLiveDocEmpty: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.empty-live-document.tooltip",
        defaultMessage: "Doc cannot be empty"
    }
});
const $27a594aa59e1555a$export$7cbd5d08127bc63b = ()=>{
    const toolbarButtonRef = (0, $42omo.useRef)(null);
    const getTargetEditorId = ()=>{
        const editors = Array.from(toolbarButtonRef.current?.closest('.ak-editor-content-area')?.querySelectorAll('.ProseMirror') ?? []).filter((editor)=>!editor.closest('[data-editor-popup]'));
        return editors[0]?.dataset.editorId;
    };
    return {
        toolbarButtonRef: toolbarButtonRef,
        getTargetEditorId: getTargetEditorId
    };
};
const $27a594aa59e1555a$export$dcb5614dfa43cea0 = ({ floatingToolbarButtonStyle: floatingToolbarButtonStyle, isEditorEmpty: isEditorEmpty, userOffline: userOffline })=>{
    const intl = (0, $8C5kA.default)();
    const { toolbarButtonRef: toolbarButtonRef, getTargetEditorId: getTargetEditorId } = $27a594aa59e1555a$export$7cbd5d08127bc63b();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleClick = ()=>{
        const targetEditorId = getTargetEditorId();
        if (targetEditorId) (0, $jOIil.eventHub).publishToEditor({
            event: 'start prompt',
            data: {
                targetEditorId: targetEditorId,
                adjustSelection: 'fullDocument',
                analyticSourceId: 'confluenceTitleToolbar',
                prompt: 'suggest title in confluence title toolbar'
            }
        });
    };
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        ref: toolbarButtonRef,
        isDisabled: Boolean(userOffline) || Boolean(isEditorEmpty),
        appearance: "subtle",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...floatingToolbarButtonStyle
        },
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            label: "",
            size: "xxsmall",
            appearance: "neutral"
        })
    }, intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleLabel));
    return Boolean(isEditorEmpty) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleTooltipWhenLiveDocEmpty) : intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleTooltipWhenDocEmpty),
        position: "top-start"
    }, button) : button;
};
















var $cOrQJ = parcelRequire("cOrQJ");


var $d7r2R = parcelRequire("d7r2R");










const $99bed9051c477495$var$aiPrismColor = {
    'prism.border.step.1': {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    'prism.border.step.2': {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    'prism.border.step.3': {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    'prism.border.step.4': {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $99bed9051c477495$var$paragraphStyle = (0, $ecnYn.xcss)({
    // @ts-expect-error
    color: "var(--ds-text-subtlest, #6B6E76)",
    // @ts-expect-error
    padding: '0 0 0 4px'
});
const $99bed9051c477495$var$AISuggestedImageHeaderLoadingContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    // @ts-expect-error
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $99bed9051c477495$var$AI_SUGGESTED_IMAGE_HEADER = 'ai-suggested-image-header';
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $99bed9051c477495$var$i18n = (0, $cgtv4.defineMessages)({
    suggestingAHeaderImage: {
        id: "ai-suggested-image-header.suggestingAHeaderImage",
        defaultMessage: "Looking for a matching header image"
    }
});
const $99bed9051c477495$export$43b100b850485fb = ({ isUploadingPicture: isUploadingPicture, isAIUnsplashImage: isAIUnsplashImage, isFixedWidthImageOption: isFixedWidthImageOption })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({});
    const coverImageWidth = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_WIDTH) : width;
    const dynamicCoverImageHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : (0, $3WPGR.getDynamicCoverImageHeight)(coverImageWidth);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const aiSuggestedImageLoadingInlineCss = {
        height: `${dynamicCoverImageHeight - 24}px`
    };
    /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ const aiSuggestedImagePrismBackground = (0, $ecnYn.xcss)({
        background: `conic-gradient(
			from var(--panel-gradient-angle, 270deg),
				${$99bed9051c477495$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
				${$99bed9051c477495$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
				${$99bed9051c477495$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
				${$99bed9051c477495$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
				${$99bed9051c477495$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
			)`,
        // @ts-expect-error
        borderRadius: `calc(${// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
        "var(--ds-radius-small, 3px)"} + ${"var(--ds-border-width, 1px)"})`,
        // @ts-expect-error
        padding: "var(--ds-border-width, 1px)",
        position: 'absolute',
        width: 'calc(100% - 48px)',
        left: '24px',
        top: '24px'
    });
    /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isUploadingPicture && isAIUnsplashImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: aiSuggestedImagePrismBackground,
        style: aiSuggestedImageLoadingInlineCss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $99bed9051c477495$var$AISuggestedImageHeaderLoadingContainer,
        testId: `${$99bed9051c477495$var$AI_SUGGESTED_IMAGE_HEADER}-modal-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7r2R.default), {
        alt: "test"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $99bed9051c477495$var$paragraphStyle
    }, formatMessage($99bed9051c477495$var$i18n.suggestingAHeaderImage))))));
};


/* AlignmentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $ghftu = parcelRequire("ghftu");


var $6bJyJ = parcelRequire("6bJyJ");


var $kiZiu = parcelRequire("kiZiu");




var $dcJ7R = parcelRequire("dcJ7R");




var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");











var $aV3a0 = parcelRequire("aV3a0");

const $315ee4abb467f669$var$dropdownContainerStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.075',
    paddingLeft: 'space.075'
});
const $315ee4abb467f669$var$dropdownMenuStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $315ee4abb467f669$var$IconStyles = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3izwfg _1bsbzwfg _zs12lb4i _fb25u2gc _3mngglyw",
            __cmplp.isSelected ? "_19itfyzg" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $315ee4abb467f669$var$i18n = (0, $cgtv4.defineMessages)({
    leftAlignmentIconLabel: {
        id: "title-area-content-components.toolbar-above-title.left-alignment-icon.label",
        defaultMessage: "Align Left"
    },
    centerAlignmentIconLabel: {
        id: "title-area-content-components.toolbar-above-title.center-alignment-icon.label",
        defaultMessage: "Align Center"
    },
    dropdownMenuLeftAlignedIconLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-left-aligned-icon.label",
        defaultMessage: "Left Aligned"
    },
    dropdownMenuCenterAlignedIconLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-center-aligned-icon.label",
        defaultMessage: "Center Aligned"
    },
    dropdownMenuAlignmentMenuLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-alignment-icon.label",
        defaultMessage: "Select for alignment options"
    },
    headerAlignmentTooltip: {
        id: "title-area-content-components.toolbar-above-title.header-alignment-tooltip",
        defaultMessage: "Header alignment"
    },
    leftAlignHeadingTooltip: {
        id: "title-area-content-components.toolbar-above-title.left-align-heading-tooltip",
        defaultMessage: "Left align header"
    },
    centerAlignHeadingTooltip: {
        id: "title-area-content-components.toolbar-above-title.center-align-heading-tooltip",
        defaultMessage: "Center align header"
    }
});
const $315ee4abb467f669$export$ed732f9c06c51576 = ({ alignmentButtonContainer: alignmentButtonContainer, userOffline: userOffline, createAnalyticsEvent: createAnalyticsEvent, flags: flags, contentType: contentType, alignmentButtonState: alignmentButtonState, coverPictureState: coverPictureState, contentId: contentId, setIsAlignmentDropdownOpen: setIsAlignmentDropdownOpen, isAlignmentDropdownOpen: isAlignmentDropdownOpen })=>{
    const intl = (0, $8C5kA.default)();
    const updateAlignmentState = alignmentButtonState?.toggleAlignmentButton;
    const updateCoverPictureWidthState = coverPictureState?.toggleCoverPictureWidthButton;
    const { updatePageTitleProperty: updatePageTitleProperty, isUpdatingAlignment: isUpdatingAlignment } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        updateAlignmentState: updateAlignmentState,
        updateCoverPictureWidthState: updateCoverPictureWidthState,
        contentType: contentType,
        flags: flags
    });
    const createAlignmentButtonAnalytics = (0, $42omo.useCallback)((alignment)=>{
        const alignmentName = alignment.charAt(0).toUpperCase() + alignment.slice(1);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                source: `${alignment}AlignmentButton`,
                actionSubject: 'button',
                actionSubjectId: `pageTitle${alignmentName}AlignButton`
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onAlignmentButtonClick = async (alignment)=>{
        if (alignmentButtonContainer.state.alignmentButtonState === alignment || isUpdatingAlignment) // don't mutate state since it's the current state or it's already trying to mutate the state
        return;
        alignmentButtonContainer.setIsUpdatingAlignment(true);
        alignmentButtonContainer.toggleAlignmentButton(alignment);
        await updatePageTitleProperty(JSON.stringify({
            titleLayoutAlignment: alignment
        }));
        alignmentButtonContainer.setIsUpdatingAlignment(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb12am"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: intl.formatMessage($315ee4abb467f669$var$i18n.headerAlignmentTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.075"
                }, alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                    label: intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuLeftAlignedIconLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
                    label: intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuCenterAlignedIconLabel)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                })),
                ref: triggerRef,
                label: intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuAlignmentMenuLabel),
                testId: `${alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? 'left' : 'center'}-alignment-dropdown-menu`,
                appearance: "subtle",
                shouldFitContainer: true,
                isDisabled: userOffline
            })),
        spacing: "compact",
        onOpenChange: ()=>setIsAlignmentDropdownOpen(!isAlignmentDropdownOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        columnGap: "space.025",
        xcss: $315ee4abb467f669$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($315ee4abb467f669$var$IconStyles, {
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($315ee4abb467f669$var$i18n.leftAlignHeadingTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>{
            createAlignmentButtonAnalytics((0, $jVylI.TitleAlignmentType).LEFT.toLowerCase());
            onAlignmentButtonClick((0, $jVylI.TitleAlignmentType).LEFT);
        },
        isDisabled: userOffline || alignmentButtonContainer.state.isUpdatingAlignment,
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
        label: intl.formatMessage($315ee4abb467f669$var$i18n.leftAlignmentIconLabel),
        testId: "left-alignment-button"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($315ee4abb467f669$var$IconStyles, {
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($315ee4abb467f669$var$i18n.centerAlignHeadingTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>{
            createAlignmentButtonAnalytics((0, $jVylI.TitleAlignmentType).CENTER.toLowerCase());
            onAlignmentButtonClick((0, $jVylI.TitleAlignmentType).CENTER);
        },
        isDisabled: userOffline || alignmentButtonContainer.state.isUpdatingAlignment,
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
        label: intl.formatMessage($315ee4abb467f669$var$i18n.centerAlignmentIconLabel),
        testId: "center-alignment-button"
    }))))))));
};


/* DictationButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @experimental
 * This component is a prototype and is not ready to be used in production.
 */ 

















var $ccHMk = parcelRequire("ccHMk");


var $bAxHS = parcelRequire("bAxHS");

// Pulse animation for recording indicator
const $899989bd7fab0eeb$var$pulseAnimation = null;
const $899989bd7fab0eeb$var$dictationButtonStyles = {
    recordingDot: "_2rko1ssb _y44v1g8x _kqswstnw _154iidpf _1xi21n1a _1bsb1y44 _4t3i1y44 _bfhkybec",
    microphoneContainer: "_kqswh2mm _1e0c116y _4cvr1h6o _2hwx1b66"
};
const $899989bd7fab0eeb$var$i18n = (0, $cgtv4.defineMessages)({
    dictationLabel: {
        id: "title-area-content-components.toolbar-above-title.dictation-button.label",
        defaultMessage: "Dictation"
    },
    voiceTypingText: {
        id: "title-area-content-components.toolbar-above-title.dictation-button.text",
        defaultMessage: "Voice typing"
    }
}); // Helper function to directly test if speech recognition is available
const $899989bd7fab0eeb$var$checkSpeechRecognitionSupport = ()=>{
    if (typeof window === 'undefined') return false; // First check if the APIs exist
    const hasSpeechRecognition = 'SpeechRecognition' in window;
    const hasWebkitSpeechRecognition = 'webkitSpeechRecognition' in window; // Try to create an instance to truly confirm it works
    try {
        if (hasWebkitSpeechRecognition) {
            // Try to create a webkitSpeechRecognition instance
            const WebkitSpeechRecognition = window.webkitSpeechRecognition;
            if (WebkitSpeechRecognition) {
                const recognition = new WebkitSpeechRecognition();
                return !!recognition;
            }
        } else if (hasSpeechRecognition) {
            // Try to create a SpeechRecognition instance
            const SpeechRecognition = window.SpeechRecognition;
            if (SpeechRecognition) {
                const recognition = new SpeechRecognition();
                return !!recognition;
            }
        }
    } catch (error) {}
    return false;
};
const $899989bd7fab0eeb$export$9c8a41ef2f037f7c = ({ userOffline: userOffline })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isDictating, setIsDictating] = (0, $42omo.useState)(false);
    const [isSupported, setIsSupported] = (0, $42omo.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)('');
    const recognitionRef = (0, $42omo.useRef)(null);
    const isMounted = (0, $42omo.useRef)(false);
    const floatingButtonRef = (0, $42omo.useRef)(null); // Add ref for tracking session duration
    const sessionStartTimeRef = (0, $42omo.useRef)(0); // Track the last inserted transcript to avoid duplicates
    const lastInsertedTranscriptRef = (0, $42omo.useRef)(''); // Generate unique ID for this component instance to avoid conflicts
    const componentId = (0, $42omo.useId)();
    const componentIdRef = (0, $42omo.useRef)(`dictation-floating-button${componentId}`); // Check if browser supports speech recognition after component mounts
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true; // Use the helper function to check support
        const supported = $899989bd7fab0eeb$var$checkSpeechRecognitionSupport();
        setIsSupported(supported);
        if (!supported) setErrorMessage('Speech recognition not supported in this browser');
         // Create the floating button element when component mounts
        if (typeof document !== 'undefined') {
            // Create floating button with unique ID
            const buttonElement = document.createElement('div');
            buttonElement.setAttribute('id', componentIdRef.current);
            buttonElement.setAttribute('data-testid', 'dictation-floating-button');
            buttonElement.setAttribute('role', 'button');
            buttonElement.setAttribute('aria-label', 'Stop voice typing');
            buttonElement.setAttribute('tabindex', '0');
            document.body.appendChild(buttonElement);
            floatingButtonRef.current = buttonElement;
        }
        return ()=>{
            isMounted.current = false; // Remove the elements when component unmounts
            if (floatingButtonRef.current && document.body.contains(floatingButtonRef.current)) document.body.removeChild(floatingButtonRef.current);
        };
    }, []);
    // Define stopDictation function
    const stopDictation = (0, $42omo.useCallback)(()=>{
        if (recognitionRef.current) try {
            recognitionRef.current.stop();
        } catch (error) {} finally{
            recognitionRef.current = null;
            setIsDictating(false); // Hide the button
            if (floatingButtonRef.current) floatingButtonRef.current.style.display = 'none';
             // Calculate session duration in seconds
            if (sessionStartTimeRef.current > 0) {
                const sessionDurationSeconds = Math.round((Date.now() - sessionStartTimeRef.current) / 1000); // Send analytics event with session duration
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'completed',
                        actionSubject: 'dictationSession',
                        actionSubjectId: 'voiceTyping',
                        attributes: {
                            sessionDurationSeconds: sessionDurationSeconds
                        }
                    }
                }).fire(); // Reset session start time
                sessionStartTimeRef.current = 0;
            }
        }
    }, [
        createAnalyticsEvent
    ]);
    // Function to insert final text into the editor
    const insertText = (0, $42omo.useCallback)((text)=>{
        try {
            const selection = window.getSelection();
            if (!selection || !selection.rangeCount) return;
            const range = selection.getRangeAt(0); // Insert final text directly
            range.deleteContents();
            const textNode = document.createTextNode(text);
            range.insertNode(textNode); // Move cursor to end of inserted text
            try {
                if (textNode.parentNode) {
                    range.selectNode(textNode);
                    range.collapse(false); // collapse to end
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            } catch (e) {}
        } catch (error) {}
    }, []); // Define startDictation function
    const startDictation = (0, $42omo.useCallback)(()=>{
        // Double-check we're in a browser environment and API is supported
        if (typeof window === 'undefined') {
            setErrorMessage('Not in a browser environment');
            setIsDictating(false);
            return;
        } // Re-check support at runtime
        const supported = $899989bd7fab0eeb$var$checkSpeechRecognitionSupport();
        if (!supported) {
            setErrorMessage('Speech recognition not supported in this browser');
            setIsDictating(false);
            return;
        }
        try {
            // Record start time when dictation begins
            sessionStartTimeRef.current = Date.now(); // Get the right speech recognition constructor
            const SpeechRecognitionAPI = window.webkitSpeechRecognition || window.SpeechRecognition;
            if (!SpeechRecognitionAPI) {
                setErrorMessage('Speech Recognition API not found');
                setIsDictating(false);
                return;
            } // Create a new recognition instance
            const recognition = new SpeechRecognitionAPI(); // Configure the recognition - disable interim results for simpler handling
            recognition.continuous = true;
            recognition.interimResults = false; // Only show final recognized text
            recognition.lang = 'en-US'; // Default to English
            // Reset transcript tracking when starting new dictation
            lastInsertedTranscriptRef.current = ''; // Set up the event handlers
            recognition.onresult = (event)=>{
                if (!isMounted.current) return; // Get the last result (most complete transcript)
                // Since interimResults is false, all results should be final
                const lastResultIndex = event.results.length - 1;
                if (lastResultIndex < 0) return;
                const lastResult = event.results[lastResultIndex];
                if (!lastResult.isFinal) return;
                const newTranscript = lastResult[0].transcript.trim();
                const lastInserted = lastInsertedTranscriptRef.current.trim(); // Extract only the NEW portion by comparing with what we've already inserted
                if (newTranscript.startsWith(lastInserted)) {
                    const newText = newTranscript.slice(lastInserted.length).trim();
                    if (newText) {
                        // Update the tracker
                        lastInsertedTranscriptRef.current = newTranscript; // Insert only the new portion
                        insertText(`${newText} `);
                    }
                } else if (newTranscript !== lastInserted) {
                    // Edge case: transcript doesn't start with our last inserted text
                    // This could happen if the API resets or there's a mismatch
                    // Insert the whole thing and update our tracker
                    lastInsertedTranscriptRef.current = newTranscript;
                    insertText(`${newTranscript} `);
                }
            }; // Add network error handling
            recognition.onerror = (event)=>{
                if (!isMounted.current) return; // Handle network errors specifically
                if (event.error === 'network') {
                    setErrorMessage('Network error. Please check your connection and try again.'); // Attempt to restart after a network error
                    if (isDictating) setTimeout(()=>{
                        if (isMounted.current && isDictating) try {
                            recognition.start();
                        } catch (retryError) {
                            setIsDictating(false);
                            setErrorMessage('Failed to restart after network error');
                        }
                    }, 2000); // Give network time to recover
                } else {
                    // Original error handling
                    const errorMsg = `Recognition error: ${event.error || 'unknown error'}`;
                    setErrorMessage(errorMsg);
                    setIsDictating(false); // If permission denied, show more specific message
                    if (event.error === 'not-allowed' || event.error === 'permission-denied') {
                        const permissionMsg = 'Microphone access denied. Please allow microphone access in your browser settings.';
                        setErrorMessage(permissionMsg);
                    }
                }
            }; // Add a robust retry mechanism to onend handler
            recognition.onend = ()=>{
                if (!isMounted.current) return; // If we're supposed to be dictating but the recognition stopped, restart it
                if (isDictating) {
                    // Track retry attempts
                    const maxRetries = 3;
                    let retryCount = 0;
                    const attemptRestart = ()=>{
                        try {
                            // Restart recognition immediately
                            recognition.start();
                        } catch (error) {
                            retryCount++;
                            if (retryCount < maxRetries) // If immediate restart fails, try with exponential backoff
                            setTimeout(()=>{
                                if (isMounted.current && isDictating) attemptRestart();
                            }, Math.min(100 * Math.pow(2, retryCount), 2000)); // Exponential backoff with max 2s
                            else {
                                setIsDictating(false);
                                setErrorMessage('Connection issue. Please try again.');
                            }
                        }
                    };
                    attemptRestart();
                }
            }; // Start listening
            recognition.start(); // Show the floating button
            if (floatingButtonRef.current) floatingButtonRef.current.style.display = 'flex';
             // Save the recognition instance to the ref for later access
            recognitionRef.current = recognition;
        } catch (error) {
            if (error instanceof Error) {
                const errorMsg = `Failed to start dictation: ${error.message}`;
                setErrorMessage(errorMsg);
            } else {
                const errorMsg = 'Failed to start dictation: unknown error';
                setErrorMessage(errorMsg);
            }
            setIsDictating(false);
        }
    }, [
        isDictating,
        insertText
    ]);
    // Update the button when dictation state changes
    (0, $42omo.useEffect)(()=>{
        if (!floatingButtonRef.current) return;
        const button = floatingButtonRef.current;
        if (isDictating) {
            // Find the object sidebar container
            const sidebarContainer = document.querySelector('[data-testid="object-sidebar-container"]'); // Set button styles
            Object.assign(button.style, {
                position: 'relative',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                zIndex: '1',
                background: "var(--ds-background-danger-bold, #C9372C)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                cursor: 'pointer',
                marginBottom: "var(--ds-space-200, 16px)",
                marginTop: "var(--ds-space-negative-100, -8px)"
            }); // Append the button to the sidebar container (renders below Rovo button)
            if (sidebarContainer) {
                button.setAttribute('data-testid', 'dictation-floating-button-sidebar');
                sidebarContainer.appendChild(button);
            } else {
                button.setAttribute('data-testid', 'dictation-floating-button');
                Object.assign(button.style, {
                    position: 'fixed',
                    bottom: '8px',
                    right: '24px',
                    marginTop: '0'
                });
            } // Set content with microphone icon
            button.innerHTML = `
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M12 15C14.21 15 16 13.21 16 11V5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5V11C8 13.21 9.79 15 12 15Z" fill="white"/>
					<path d="M19 11H17.3C17.3 14.07 14.76 16.61 11.69 16.61L11.69 16.61C8.61 16.61 6.07 14.07 6.07 11H4.38C4.38 14.62 7 17.6 10.5 18.24V21H13.5V18.24C17 17.6 19 14.62 19 11Z" fill="white"/>
				</svg>
			`; // Add tooltip title
            button.setAttribute('title', 'Click to stop dictation'); // Add click event listener
            button.onclick = stopDictation; // Add keyboard support (Enter and Space keys)
            const handleKeyDown = (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    stopDictation();
                }
            };
            button.addEventListener('keydown', handleKeyDown); // Cleanup function
            return ()=>{
                button.removeEventListener('keydown', handleKeyDown);
            };
        } else {
            // Hide the button when not dictating
            button.style.display = 'none';
            button.setAttribute('data-testid', 'dictation-floating-button');
        }
    }, [
        isDictating,
        stopDictation
    ]);
    // Stop dictation immediately when user goes offline
    (0, $42omo.useEffect)(()=>{
        if (userOffline && isDictating) stopDictation();
    }, [
        userOffline,
        isDictating,
        stopDictation
    ]);
    const handleDictationClick = (0, $42omo.useCallback)(()=>{
        // Reset any error messages when trying again
        setErrorMessage(''); // Determine action based on current state
        const willStart = !isDictating; // Fire analytics event
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: willStart ? 'started' : 'stopped',
                source: 'dictationButton',
                actionSubject: 'pageTitle',
                actionSubjectId: 'dictationButton'
            }
        }).fire(); // Perform action immediately without race conditions
        if (willStart) {
            setIsDictating(true); // Use setTimeout to allow state update to complete before starting
            setTimeout(()=>{
                startDictation();
            }, 0);
        } else stopDictation();
    }, [
        createAnalyticsEvent,
        isDictating,
        startDictation,
        stopDictation
    ]); // Clean up the recognition object when the component unmounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (recognitionRef.current) try {
                recognitionRef.current.stop();
            } catch (error) {}
        };
    }, []); // Get a more specific tooltip message based on state
    const getTooltipMessage = ()=>{
        if (errorMessage) return errorMessage;
        if (!isSupported) return 'Speech recognition not supported in this browser';
        return isDictating ? 'Stop Voice Typing' : 'Start Voice Typing';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "dictation-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: getTooltipMessage(),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleDictationClick,
        isDisabled: userOffline,
        testId: "dictation-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $899989bd7fab0eeb$var$dictationButtonStyles.microphoneContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAxHS))), {
        label: intl.formatMessage($899989bd7fab0eeb$var$i18n.dictationLabel),
        color: isDictating ? "var(--ds-icon-danger, #C9372C)" : undefined
    }), isDictating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "recording-indicator",
        className: (0, $gMc0m.default)([
            $899989bd7fab0eeb$var$dictationButtonStyles.recordingDot
        ])
    })), intl.formatMessage($899989bd7fab0eeb$var$i18n.voiceTypingText))));
};


const $c715bbb1f8876107$var$toolbarAboveTitleBoxStylesBase = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 'space.050'
});
const $c715bbb1f8876107$var$toolbarAboveTitleLeftAlignmentStyles = (0, $ecnYn.xcss)({
    alignItems: 'start'
});
const $c715bbb1f8876107$var$toolbarAboveTitleCenterAlignmentStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    marginBottom: 'space.050'
});
const $c715bbb1f8876107$var$toolbarAboveTitleBottomSpacingStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.200'
});
const $c715bbb1f8876107$var$toolbarAboveTitleHiddenStyles = (0, $ecnYn.xcss)({
    overflowX: 'hidden'
});
const $c715bbb1f8876107$var$coverPictureAndButtonWithCoverPictureBoxStylesNew = (0, $ecnYn.xcss)({
    width: '100%',
    marginBottom: 'space.0'
});
const $c715bbb1f8876107$var$coverPictureAndButtonFixedWidthHeightStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    height: `${(0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT)}px`
});
const $c715bbb1f8876107$var$coverPictureAndButtonFullWidthHeightStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    height: `${(0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE)}`
});
const $c715bbb1f8876107$var$toolbarStyle = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to align this to the design system
    marginTop: '-22px'
});
const $c715bbb1f8876107$var$editorAppearanceButtonBoxXcss = (0, $ecnYn.xcss)({
    marginRight: 'space.025'
});
const $c715bbb1f8876107$var$rightControlsGroupXcss = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.0'
});
const $c715bbb1f8876107$var$rightControlsGroupClassicXcss = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.075'
});
const $c715bbb1f8876107$var$rightControlsGroupLiveXcss = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c715bbb1f8876107$var$ToolbarButtonsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isTitleCenterAligned: isTitleCenterAligned, shouldShowToolbar: shouldShowToolbar, isReadOnly: isReadOnly, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7vuon _2rkofajl _v564134x _kqswh2mm _4t3i1ns9 _1bsb1ns9 _19bvidpf _1pby1kze _1e0c1txw _gy1p1b66 _1fvdglyw _1df215vq",
            (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isTitleCenterAligned ? "_1wpz1h6o" : "_1wpz1wug",
            (0, $9wGTI.fg)('live_pages_content_jump_mitigation') ? "_1yt4v77o" : "_1yt41b66",
            __cmplp.shouldShowToolbar ? "_tzy4kb7n" : "_tzy48dtj",
            __cmplp.isReadOnly ? "_3um015vq" : "_3um0ewfl",
            __cmplp.hasCoverPicture && (__cmplp.hasEmoji ? "_19pkoahv" : "_19pk1ejb"),
            __cmplp.className
        ])
    });
});
const $c715bbb1f8876107$var$floatingToolbarButtonStyle = {
    height: '32px',
    alignItems: 'center'
};
const $c715bbb1f8876107$export$1ba161aab679566b = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, userOffline: userOffline, isUnpublishedDraft: isUnpublishedDraft, isTitleDisabled: isTitleDisabled, isCoverPictureModalOpen: isCoverPictureModalOpen, hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused, setSelectedEmoji: setSelectedEmoji, onEmojiPickerLoaded: onEmojiPickerLoaded, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isEmojiButtonFocused: isEmojiButtonFocused, hasEmoji: hasEmoji, contentType: contentType, isPublishingContent: isPublishingContent, hasContentState: hasContentState, isSpaceOverview: isSpaceOverview, contentStateState: contentStateState, isTitleCenterAligned: isTitleCenterAligned, alignmentButtonState: alignmentButtonState, coverPictureState: coverPictureState, isSecondEmojiPickerOpen: isSecondEmojiPickerOpen, flags: flags, isReadOnly: isReadOnly, isEditorEmpty: isEditorEmpty, coverPictureWidth: coverPictureWidth, spaceKey: spaceKey, contentComponentsDisabled: contentComponentsDisabled, isStatusDisconnected: isStatusDisconnected, isAIUnsplashImage: isAIUnsplashImage, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, coverImageWidthCached: coverImageWidthCached, isUnsplash: isUnsplash, hideSuggestedTitle: hideSuggestedTitle = false, hideContentState: hideContentState = false, hideEditorAppearanceButton: hideEditorAppearanceButton = false, hideAlignmentButton: hideAlignmentButton = false, hideContentModeButton: hideContentModeButton = false, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, autoPageEmojiCohort: autoPageEmojiCohort, emojiTitleDiscovered: emojiTitleDiscovered })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)(); // Hide toolbar when live page is rendered in preview panel
    const shouldHideToolbarInPreviewPanel = isLivePage && (0, $eToX6.isInPreviewPanel)(); // Determine the appropriate testId for the toolbar wrapper
    const getToolbarTestId = ()=>{
        if (shouldHideToolbarInPreviewPanel) return 'toolbar-above-title-wrapper-hidden';
        if (isTitleCenterAligned) return 'toolbar-above-title-wrapper-centered';
        return 'toolbar-above-title-wrapper';
    };
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isFixedWidth = coverImageWidthCached && isServerPlaceholder ? coverImageWidthCached === (0, $jVylI.COVERPICTUREWIDTH).FIXED : coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const [isContentStateButtonFocused, setIsContentStateButtonFocused] = (0, $42omo.useState)(false);
    const [isContentStateMenuOpen, setIsContentStateMenuOpen] = (0, $42omo.useState)(false);
    const [isAlignmentDropdownOpen, setIsAlignmentDropdownOpen] = (0, $42omo.useState)(false);
    const [isAppearanceDropdownOpen, setIsAppearanceDropdownOpen] = (0, $42omo.useState)(false); // Tracks if any of the hover buttons are focused (means user tabbed to a hover button)
    const [isHoverButtonFocused, _setIsHoverButtonFocused] = (0, $42omo.useState)(isAddHeaderImageButtonFocused || isEmojiButtonFocused || isContentStateButtonFocused);
    const onlineShouldShowToolbar = isSecondEmojiPickerOpen || isHoverButtonFocused || isContentStateMenuOpen || isCoverPictureModalOpen || isAlignmentDropdownOpen || isAppearanceDropdownOpen && ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true));
    const [shouldShowToolbarPrevOnlineValue, setShouldShowToolbarPrevOnlineValue] = (0, $42omo.useState)(onlineShouldShowToolbar);
    (0, $42omo.useEffect)(()=>{
        if (!userOffline) setShouldShowToolbarPrevOnlineValue(onlineShouldShowToolbar);
    }, [
        userOffline,
        onlineShouldShowToolbar
    ]);
    const shouldShowToolbar = !isReadOnly && (userOffline ? shouldShowToolbarPrevOnlineValue : onlineShouldShowToolbar);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Whenever we leave the editor, we need to clean up and reset the content state container values on unmount,
            // otherwise when the user opens editor, previous values are incorrectly persisted (could also do this in breadcrumbs but chose here)
            contentStateState.resetToDefaults();
            coverPictureState.resetToDefaults();
            alignmentButtonState?.resetToDefaults();
        };
    }, [
        contentStateState,
        coverPictureState,
        alignmentButtonState
    ]);
    const editorAppearanceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RPbY.EditorAppearanceButtonNext), {
        contentId: contentId,
        disabled: !!contentComponentsDisabled,
        isStatusDisconnected: !!isStatusDisconnected,
        setIsAppearanceDropdownOpen: setIsAppearanceDropdownOpen,
        isAppearanceDropdownOpen: isAppearanceDropdownOpen
    });
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({
        isFixedWidth: isFixedWidth
    });
    const coverImageWidth = isFixedWidth ? (0, $75Ax4.COVER_IMAGE_FIXED_WIDTH) : width;
    const dynamicCoverImageHeight = isFixedWidth ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : (0, $3WPGR.getDynamicCoverImageHeight)(coverImageWidth);
    const [coverPictureAndButtonWrapperHeight, setCoverPictureAndButtonWrapperHeight] = (0, $42omo.useState)(dynamicCoverImageHeight);
    const aiSuggestedImageHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99bed9051c477495$export$43b100b850485fb), {
        isUploadingPicture: isUploadingPicture,
        isAIUnsplashImage: isAIUnsplashImage,
        isFixedWidthImageOption: isFixedWidth
    });
    const coverPicAndButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7b9e49b2b71ddf8$export$bd378463497634f0), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        hasCoverPicture: hasCoverPicture,
        isUploadingPicture: isUploadingPicture,
        hasContentState: hasContentState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: $c715bbb1f8876107$var$floatingToolbarButtonStyle,
        isFixedWidthImageOption: isFixedWidth,
        updateHeight: setCoverPictureAndButtonWrapperHeight,
        currentHeight: coverPictureAndButtonWrapperHeight,
        isReadOnly: isReadOnly,
        spaceKey: spaceKey,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        isAIUnsplashImage: isAIUnsplashImage,
        isUnsplash: isUnsplash,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        width: width,
        coverImageWidth: coverImageWidth,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    });
    const onContentStateUpdatedSubscription = (0, $42omo.useCallback)((_, data)=>{
        const { contentStateUpdated: contentStateUpdated } = data || {};
        try {
            const contentState = JSON.parse(contentStateUpdated?.value);
            contentStateState.setContentState(contentState?.contentState);
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        contentStateState
    ]);
    const onContentStateDeletedSubscription = (0, $42omo.useCallback)(()=>{
        contentStateState.setContentState(null);
    }, [
        contentStateState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ToolbarAboveTitleContentStateUpdated',
        delta: 'contentStateUpdated',
        contentId: contentId,
        contentType: contentType || 'page',
        onDataReceived: onContentStateUpdatedSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'TitleAreaContentComponentsContentStateDeleted',
        delta: 'contentStateDeleted',
        contentId: contentId,
        contentType: contentType || 'page',
        onDataReceived: onContentStateDeletedSubscription
    });
    const shouldRenderAppearanceButton = !hideEditorAppearanceButton && (isSpaceOverview || isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer)
        ]
    }, (alignmentButtonContainer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $c715bbb1f8876107$var$toolbarAboveTitleBoxStylesBase,
                isTitleCenterAligned ? $c715bbb1f8876107$var$toolbarAboveTitleCenterAlignmentStyles : $c715bbb1f8876107$var$toolbarAboveTitleLeftAlignmentStyles,
                $c715bbb1f8876107$var$toolbarAboveTitleBottomSpacingStyle,
                shouldHideToolbarInPreviewPanel && $c715bbb1f8876107$var$toolbarAboveTitleHiddenStyles
            ],
            testId: getToolbarTestId()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, aiSuggestedImageHeader), hasCoverPicture || isUploadingPicture || aiSuggestedUnsplashImages?.[0] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $c715bbb1f8876107$var$toolbarStyle,
                (isUploadingPicture || hasCoverPicture) && $c715bbb1f8876107$var$coverPictureAndButtonWithCoverPictureBoxStylesNew,
                (isUploadingPicture || hasCoverPicture) && isFixedWidth && $c715bbb1f8876107$var$coverPictureAndButtonFixedWidthHeightStyle,
                (isUploadingPicture || hasCoverPicture) && !isFixedWidth && $c715bbb1f8876107$var$coverPictureAndButtonFullWidthHeightStyle
            ],
            testId: "cover-pic-and-button-wrapper",
            "data-id": "cover-pic-and-button-wrapper"
        }, coverPicAndButton) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c715bbb1f8876107$var$ToolbarButtonsWrapper, {
            isUploadingPicture: isUploadingPicture,
            hasCoverPicture: hasCoverPicture,
            isTitleCenterAligned: isTitleCenterAligned,
            shouldShowToolbar: shouldShowToolbar,
            hasEmoji: hasEmoji,
            isReadOnly: isReadOnly,
            "data-testid": "toolbar-buttons-wrapper"
        }, !hideAlignmentButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $315ee4abb467f669$export$ed732f9c06c51576), {
            alignmentButtonContainer: alignmentButtonContainer,
            userOffline: userOffline,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            contentType: contentType,
            alignmentButtonState: alignmentButtonState,
            coverPictureState: coverPictureState,
            contentId: contentId,
            setIsAlignmentDropdownOpen: setIsAlignmentDropdownOpen,
            isAlignmentDropdownOpen: isAlignmentDropdownOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ea2840cbc0b61fe$export$e6ce3311a4d41b7f), {
            contentId: contentId,
            userOffline: userOffline,
            isUnpublishedDraft: isUnpublishedDraft,
            isTitleDisabled: isTitleDisabled,
            setSelectedEmoji: setSelectedEmoji,
            onEmojiPickerLoaded: onEmojiPickerLoaded,
            onUpdateStartEmoji: onUpdateStartEmoji,
            onUpdateEndEmoji: onUpdateEndEmoji,
            floatingToolbarButtonStyle: $c715bbb1f8876107$var$floatingToolbarButtonStyle,
            contentType: contentType,
            autoPageEmojiCohort: autoPageEmojiCohort,
            emojiTitleDiscovered: emojiTitleDiscovered
        }), !hideContentState && !hasContentState && !isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $770cae54ba9545b3$export$826c215475ad6cbb), {
            contentId: contentId,
            hasContentState: hasContentState,
            contentType: contentType,
            userOffline: userOffline,
            setIsContentStateButtonFocused: setIsContentStateButtonFocused,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen,
            floatingToolbarButtonStyle: $c715bbb1f8876107$var$floatingToolbarButtonStyle
        }), hasCoverPicture || isUploadingPicture ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "cover-pic-and-button-wrapper"
        }, coverPicAndButton), !hideSuggestedTitle && isAIEnabledForContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27a594aa59e1555a$export$dcb5614dfa43cea0), {
            isEditorEmpty: isEditorEmpty,
            floatingToolbarButtonStyle: $c715bbb1f8876107$var$floatingToolbarButtonStyle,
            userOffline: userOffline
        }), !hideContentModeButton && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "title-toolbar-right-controls-group",
            xcss: [
                $c715bbb1f8876107$var$rightControlsGroupXcss,
                isLivePage ? $c715bbb1f8876107$var$rightControlsGroupLiveXcss : $c715bbb1f8876107$var$rightControlsGroupClassicXcss
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7e7400ce50234362$export$a8e3305d336ef5aa), {
            contentId: contentId,
            isStatusDisconnected: isStatusDisconnected
        }), shouldRenderAppearanceButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "editor-appearance-button-wrapper"
        }, editorAppearanceButton)), !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) && shouldRenderAppearanceButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c715bbb1f8876107$var$editorAppearanceButtonBoxXcss,
            testId: "editor-appearance-button-wrapper"
        }, editorAppearanceButton), (0, $6mKj3.expValEquals)('confluence-dictation-button-on-pages', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $899989bd7fab0eeb$export$9c8a41ef2f037f7c), {
            userOffline: userOffline
        })));
    });
});
$c715bbb1f8876107$export$1ba161aab679566b.displayName = 'ToolbarAboveTitle';





const $371f4180811f666e$export$d6e6222f1c69ce82 = '--toolbar-opacity';
const $371f4180811f666e$var$editorTitleWrapperStyles = {
    root: "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _1u7yidpf _mow6t94y",
    paddingTopSpace300: "_ca0q1ejb",
    paddingTopSpace0: "_ca0qze3t",
    topSpacing: "_19pkukr8 _ca0qpxbi",
    paddingBottomSpace300: "_n3td1ejb",
    newEditorTitleHoverTopPadding: "_ca0qv47k"
};
const $371f4180811f666e$var$titleBoxStylesAlignSelfCenter = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $371f4180811f666e$var$editorTitleBaseStyles = (0, $ecnYn.xcss)({
    width: '100%',
    marginTop: 'space.negative.200',
    marginBottom: 'space.400'
});
const $371f4180811f666e$var$editorTitleSmallerMarginBottomBaseStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $371f4180811f666e$var$EditorTitleWithButtonsWrapper = ({ viewMode: viewMode, isContentTopperComponentPresent: isContentTopperComponentPresent, isNewEditorBylineLayout: isNewEditorBylineLayout, hasCoverPicture: hasCoverPicture, children: children })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ $42omo.createElement("div" // TODO: Cleanup CSS when cleaning up FG PGXT-8139
    , {
        "data-testid": "editor-title-with-buttons-div",
        ...ssrPlaceholderIdProp,
        className: (0, $gMc0m.default)([
            $371f4180811f666e$var$editorTitleWrapperStyles.root,
            viewMode ? !(0, $dh538.fg)('live_pages_content_jump_mitigation') ? $371f4180811f666e$var$editorTitleWrapperStyles.paddingTopSpace300 : $371f4180811f666e$var$editorTitleWrapperStyles.paddingTopSpace0 : $371f4180811f666e$var$editorTitleWrapperStyles.paddingTopSpace0,
            isContentTopperComponentPresent && $371f4180811f666e$var$editorTitleWrapperStyles.topSpacing,
            isContentTopperComponentPresent && isNewEditorBylineLayout && $371f4180811f666e$var$editorTitleWrapperStyles.paddingBottomSpace300,
            isContentTopperComponentPresent && !hasCoverPicture && $371f4180811f666e$var$editorTitleWrapperStyles.newEditorTitleHoverTopPadding
        ])
    }, children);
};
$371f4180811f666e$var$EditorTitleWithButtonsWrapper.displayName = 'EditorTitleWithButtonsWrapper';
const $371f4180811f666e$export$860ceec1bc73beeb = ({ contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, isUnpublishedDraft: isUnpublishedDraft, children: editorTitle, isTemplateEditor: isTemplateEditor = false, isTitleCenterAligned: isTitleCenterAligned, viewMode: viewMode, contentTopperComponent: contentTopperComponent, contentClassificationMetadata: contentClassificationMetadata, hasClassification: hasClassification, spaceKey: spaceKey, isEditorEmpty: isEditorEmpty, isTitleAlignmentLoading: isTitleAlignmentLoading, contentComponentsDisabled: contentComponentsDisabled, isStatusDisconnected: isStatusDisconnected, coverPictureState: coverPictureState, titleAfterBlur: titleAfterBlur, isLivePage: isLivePage, coverImageWidthCached: coverImageWidthCached, hideSuggestedTitle: hideSuggestedTitle = false, hideContentState: hideContentState = false, hideEditorAppearanceButton: hideEditorAppearanceButton = false, hideContentModeButton: hideContentModeButton = false, hideAlignmentButton: hideAlignmentButton = false, pageTitleContent: pageTitleContent, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, autoPageEmojiCohort: autoPageEmojiCohort, emojiTitleDiscovered: emojiTitleDiscovered })=>{
    const { contentAppearance: contentAppearance } = (0, $2HGN8.useContentAppearance)();
    const isPageContentFullWidth = contentAppearance.appearance === 'full-width';
    const emojiStatusFieldName = (0, $5amrO.useEmojiStatusFieldName)();
    const { locale: locale } = (0, $8C5kA.default)();
    const prevTitleStateRef = (0, $42omo.useRef)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverview = homepageId === contentId;
    const { hideTitleToolbar: hideTitleToolbar } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showTitleToolbar = isEmbeddedConfluence ? !hideTitleToolbar : true;
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $gr7Mm.CoverPictureQuery), {
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }
    });
    const { data: emojiData, error: emojiError } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $5DJsZ.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }
    });
    const hasDefaultTitleEmoji = isLivePage && (0, $8rneB.getHasLiveDocsDefaultEmoji)(emojiData);
    const hasEmoji = !!(emojiData && ((0, $8rneB.getHasEmoji)(emojiData, emojiStatusFieldName) || hasDefaultTitleEmoji));
    const properties = data?.content?.nodes?.[0]?.properties?.nodes || []; // we only need the draft info since this will just be used to determine what component to show during edit mode
    const draft = properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
    const coverPictureInfo = (0, $3WPGR.propertyToId)(draft);
    const hasCoverPicture = !!coverPictureInfo?.value?.id;
    const isUnsplash = coverPictureInfo?.value?.id.includes('images.unsplash.com');
    const getUnsplashImage = (0, $42omo.useCallback)(async ()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_ai_unsplash_page_header', true) !== true) return;
        if (!isUnpublishedDraft && !isLivePage) return;
        if ((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_UNSPLASH_HEADER_ACCEPTED) === 'false') return;
        if (!titleAfterBlur || coverPictureState.state.hasCoverPicture || coverPictureState.state.isUploadingPicture) return;
        const currentTitleState = titleAfterBlur;
        if (prevTitleStateRef.current === currentTitleState) return;
        coverPictureState.setIsUploadingPicture(true);
        coverPictureState.setIsAIUnsplashImage(true);
        const imageSearchString = await (0, $239d2520a432cbe7$export$91130da4da46566b)({
            title: titleAfterBlur,
            locale: locale
        });
        const unsplashImages = await (0, $gTAwR.getUnsplashPhotos)(imageSearchString, 0, true);
        if (unsplashImages?.length > 0) coverPictureState.setAISuggestedUnsplashImages(unsplashImages);
        prevTitleStateRef.current = currentTitleState;
    }, [
        titleAfterBlur,
        locale,
        coverPictureState,
        isUnpublishedDraft,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        getUnsplashImage();
    }, [
        titleAfterBlur,
        getUnsplashImage
    ]);
    (0, $42omo.useEffect)(()=>{
        coverPictureState.setHasCoverPicture(hasCoverPicture);
    }, [
        hasCoverPicture,
        coverPictureState
    ]);
    const shouldRenderAboveTitle = !isTemplateEditor && showTitleToolbar;
    const isNewEditorBylineLayout = isLivePage || !isSpaceOverview && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline');
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, emojiError ? /*#__PURE__*/ $42omo.createElement((0, $b3j2Y.ErrorDisplay), {
        error: emojiError
    }) : null, /*#__PURE__*/ $42omo.createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer),
            (0, $bJX6u.ContentStateStateContainer),
            (0, $gektR.AlignmentButtonContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (emojiTitleState, contentStateState, alignmentButtonState, flags)=>/*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
            direction: "column",
            xcss: [
                $371f4180811f666e$var$editorTitleBaseStyles,
                isNewEditorBylineLayout && $371f4180811f666e$var$editorTitleSmallerMarginBottomBaseStyles
            ]
        }, /*#__PURE__*/ $42omo.createElement($371f4180811f666e$var$EditorTitleWithButtonsWrapper, {
            viewMode: !!viewMode,
            isContentTopperComponentPresent: !!contentTopperComponent,
            isNewEditorBylineLayout: isNewEditorBylineLayout,
            hasCoverPicture: hasCoverPicture
        }, shouldRenderAboveTitle ? /*#__PURE__*/ $42omo.createElement((0, $c715bbb1f8876107$export$1ba161aab679566b), {
            contentId: contentId,
            userOffline: userOffline,
            isUnpublishedDraft: isUnpublishedDraft,
            isTitleDisabled: isTitleDisabled,
            isAddHeaderImageButtonFocused: coverPictureState.state.isAddHeaderImageButtonFocused,
            isCoverPictureModalOpen: coverPictureState.state.isModalOpen,
            hasCoverPicture: hasCoverPicture,
            isUploadingPicture: coverPictureState.state.isUploadingPicture,
            setSelectedEmoji: emojiTitleState.setSelectedEmoji,
            onEmojiPickerLoaded: emojiTitleState.onEmojiPickerLoaded,
            isEmojiButtonFocused: emojiTitleState.state.isEmojiButtonFocused,
            onUpdateStartEmoji: emojiTitleState.onUpdateStart,
            onUpdateEndEmoji: emojiTitleState.onUpdateEnd,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            contentStateState: contentStateState,
            hasContentState: !!contentStateState.state.contentState,
            isSpaceOverview: isSpaceOverview,
            isTitleCenterAligned: isTitleCenterAligned,
            alignmentButtonState: alignmentButtonState,
            coverPictureState: coverPictureState,
            coverPictureWidth: coverPictureState.state.coverPictureWidth,
            isSecondEmojiPickerOpen: emojiTitleState.state.openSecondEmojiPicker,
            flags: flags,
            contentClassificationMetadata: contentClassificationMetadata,
            hasClassification: hasClassification,
            isReadOnly: viewMode,
            spaceKey: spaceKey,
            isEditorEmpty: isEditorEmpty,
            contentComponentsDisabled: contentComponentsDisabled,
            isStatusDisconnected: isStatusDisconnected,
            isAIUnsplashImage: coverPictureState.state.isAIUnsplashImage,
            aiSuggestedUnsplashImages: coverPictureState.state.aiSuggestedUnsplashImages,
            hasEmoji: hasEmoji,
            coverImageWidthCached: coverImageWidthCached,
            isUnsplash: isUnsplash,
            hideSuggestedTitle: hideSuggestedTitle,
            hideContentState: hideContentState,
            hideEditorAppearanceButton: hideEditorAppearanceButton,
            hideContentModeButton: hideContentModeButton,
            hideAlignmentButton: hideAlignmentButton,
            aiHeaderImageStatus: aiHeaderImageStatus,
            aiHeaderImageFileId: aiHeaderImageFileId,
            generateAIHeaderImage: generateAIHeaderImage,
            setAIHeaderImageStatus: setAIHeaderImageStatus,
            autoPageEmojiCohort: autoPageEmojiCohort,
            emojiTitleDiscovered: emojiTitleDiscovered
        }) : null, /*#__PURE__*/ $42omo.createElement((0, $d765f449481d5188$export$718e92491c44b3f6), {
            editorTitle: editorTitle,
            contentTopperComponent: contentTopperComponent,
            contentId: contentId,
            isTemplateEditor: isTemplateEditor,
            onUpdateStartEmoji: emojiTitleState.onUpdateStart,
            onUpdateEndEmoji: emojiTitleState.onUpdateEnd,
            isTitleDisabled: isTitleDisabled,
            isTitleCenterAligned: isTitleCenterAligned,
            linkCreation: linkCreation,
            hasCoverPicture: hasCoverPicture,
            hasEmoji: hasEmoji,
            coverPictureWidth: coverPictureState.state.coverPictureWidth,
            isRemovingEmoji: emojiTitleState.state.isRemovingEmoji,
            isReadOnly: viewMode,
            contentClassificationMetadata: contentClassificationMetadata,
            isPageContentFullWidth: isPageContentFullWidth,
            hasClassification: hasClassification,
            isTitleAlignmentLoading: isTitleAlignmentLoading,
            isSpaceOverview: isSpaceOverview,
            pageTitleContent: pageTitleContent,
            autoPageEmojiCohort: autoPageEmojiCohort,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            emojiTitleDiscovered: emojiTitleDiscovered,
            contentType: contentType
        })), isNewEditorBylineLayout && contentTopperComponent ? /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
            testId: "content-topper-wrapper",
            xcss: [
                isTitleCenterAligned && $371f4180811f666e$var$titleBoxStylesAlignSelfCenter
            ]
        }, contentTopperComponent) : null)));
};
$371f4180811f666e$export$860ceec1bc73beeb.displayName = 'EditorTitleWithTitleAreaComponents';
module.exports["EditorTitleWithTitleAreaComponents"] = $371f4180811f666e$export$860ceec1bc73beeb;

});

parcelRegister("gTAwR", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $75Ax4 = parcelRequire("75Ax4");

async function $3297a981dc10fa5b$export$c23d8af8b1b8f2d7(queryWord, pageNumber, isPageTitleComponent) {
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((responseData)=>{
        const unsplashResults = responseData.results ?? [];
        return unsplashResults.map((result)=>({
                artistName: result.user.name,
                artistUrl: result.user.links.html + (0, $75Ax4.REFERRAL_LINK),
                fullSizeImageUrl: isPageTitleComponent ? result.urls.full : result.urls.regular,
                smallSizeImageUrl: result.urls.thumb,
                description: result.description,
                downloadLink: result.links.download_location
            }));
    });
}
function $3297a981dc10fa5b$export$d3c50eeab3c808b(downloadLink) {
    (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
module.exports["getUnsplashPhotos"] = $3297a981dc10fa5b$export$c23d8af8b1b8f2d7;

});

parcelRegister("bksM6", function(module, exports) {

let $0220e6be2e1969e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0220e6be2e1969e5$var$load("7aOpi"),
    $0220e6be2e1969e5$var$load("cC68k")
]).then(()=>parcelRequire('iI06X'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3Y0iy", function(module, exports) {

let $2e3734edaadf62d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e3734edaadf62d8$var$load("dVM1q").then(()=>parcelRequire('5tKh7'));

});

parcelRegister("7833H", function(module, exports) {

let $530ba724e5b763c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $530ba724e5b763c4$var$load("4izLy"),
    $530ba724e5b763c4$var$load("6wr18"),
    $530ba724e5b763c4$var$load("fSNo2"),
    $530ba724e5b763c4$var$load("ffEVr"),
    $530ba724e5b763c4$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});


//# sourceMappingURL=TitleAreaContentComponents.7eb0b5fd.js.map
